import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import iosPromptsJson from 'src/app/product-journey-manager/journey-builder/components/prompts-sidebar/ios-prompts.json';
import androidPromptsJson from 'src/app/product-journey-manager/journey-builder/components/prompts-sidebar/android-prompts.json';
import webPromptsJson from 'src/app/product-journey-manager/journey-builder/components/prompts-sidebar/web-prompts.json';
import webMobilePromptsJson from 'src/app/product-journey-manager/journey-builder/components/prompts-sidebar/web-mobile-prompts.json';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { debounce, cloneDeep, throttle } from 'lodash';
import { WebView } from '../journey-builder/components/prompts-sidebar/web-view.enum';
import compareVersions from 'compare-versions';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var EditorCommonService = /** @class */ (function () {
    function EditorCommonService(http) {
        var _this = this;
        this.http = http;
        this.FLUTTER_VIEW_SEPARATOR = '@@';
        this.promptWidthData = new Subject();
        this.contentChangeDate = new Subject();
        // check
        this.repositionChange = new Subject();
        this.cornerRadiusDataChange = new Subject();
        this.disableBorderRadius = new Subject();
        this.disableBorderRadiusObservar = this.disableBorderRadius.asObservable();
        this.spolightData = new Subject();
        this.selectedElementData = new Subject();
        this.triggerPromptData = new Subject();
        this.requiredValueError = new Subject();
        this.elementSelectionChange = new Subject();
        this.selectedNodeChangeFromHierarchy = new Subject();
        this.changeInViewHierarchyFlag = new Subject();
        this.closeViewHierarchyDialogFlag = new Subject();
        this.promptBGImgURLError = new Subject();
        this.zIndexError = new Subject();
        this.webPncCaptureBtnClickEvent = new Subject();
        this.webPncCaptureCompleteEvent = new Subject();
        this.toggleBackdrop = new Subject();
        this.toggleBackdropBlur = new Subject();
        this.stringFillerText = '__hansel_filler__';
        this.scalingPlatformVal = null;
        this.vzData = null;
        this.viewElementChange = new Subject();
        this.hasVZDataLoaded = new Subject();
        this.onHTMLContentChange = new Subject();
        this.hasHTMLZIPLoaded = new Subject();
        this.nudgeHTMLData = new Subject();
        this.secondaryBtnToggleSub = new Subject();
        this.colContainerImgPosSub = new Subject();
        this.webPNCPositions$ = new Subject();
        this.nudgePlacement$ = new Subject();
        this.nudgeAnimation$ = new Subject();
        this.inputTimeOut = 2000;
        this.options = {
            headingStyle: 'atx'
        };
        this.hotspotOptions = {
            CIRCLE_1: 'circle_1',
            CIRCLE_2: 'circle_2',
            QUESTION: 'question',
            STAR: 'star'
        };
        this.spotlightOptions = {
            CIRCLE: 'circle',
            SQUARE: 'square'
        };
        this.androidFonts = [
            {
                name: 'Roboto',
                value: 'Roboto'
            },
            {
                name: 'NotoSerif-Regular',
                value: 'serif'
            },
            {
                name: 'Roboto-Regular',
                value: 'sans-serif'
            },
            {
                name: 'DancingScript-Regular',
                value: 'cursive'
            },
            {
                name: 'DroidSansMono',
                value: 'monospace'
            },
            {
                name: 'Roboto-Medium',
                value: 'sans-serif-medium'
            }
        ];
        this.iosFonts = [
            {
                name: 'Helvetica',
                value: 'Helvetica'
            },
            {
                name: 'Arial',
                value: 'Arial'
            },
            {
                name: 'Georgia',
                value: 'Georgia'
            },
            {
                name: 'San Francisco-Medium',
                value: 'San Francisco-Medium'
            },
            {
                name: 'San Francisco',
                value: 'San Francisco'
            },
            {
                name: 'HelveticaNeue',
                value: 'HelveticaNeue'
            },
            {
                name: 'HelveticaNeue-Medium',
                value: 'HelveticaNeue-Medium'
            }
        ];
        this.webFonts = [
            {
                name: 'Sans - Serif',
                value: 'sans-serif'
            },
            {
                name: 'Serif',
                value: 'serif'
            },
            {
                name: 'Monospace',
                value: 'monospace'
            },
            {
                name: 'Nunito Sans',
                value: 'Nunito Sans'
            },
        ];
        this.inputTypes = [
            {
                name: 'Text',
                value: 'text'
            },
            {
                name: 'Number',
                value: 'number'
            },
            {
                name: 'Email',
                value: 'email'
            }
        ];
        this.positions = {
            TL: 'Top Left',
            TC: 'Top Center',
            TR: 'Top Right',
            ML: 'Middle Left',
            MC: 'Middle Center',
            MR: 'Middle Right',
            BL: 'Bottom Left',
            BC: 'Bottom Center',
            BR: 'Bottom Right'
        };
        this.templateCategories = [
            {
                name: 'master',
                label: 'Master Template',
                desc: 'Master Template for Refs only',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'feature_highlight',
                label: 'Feature Adoption',
                desc: 'Anchor these nudges to your app elements to drive feature discovery and adoption',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'persistent_nudges',
                label: 'Persistent Nudges',
                desc: '',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'announcements_and_messages',
                label: 'Announcements and messages',
                desc: 'Use these nudges to display messages and feature announcements to users',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'feedback',
                label: 'Feedback',
                desc: 'Use these nudges to collect user feedback',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'enroll_users',
                label: 'Enroll Users',
                desc: 'Use these nudges to enroll users to subscriptions, beta signups',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'alerts',
                label: 'Alerts',
                desc: 'Use these nudges to show important information and alerts to users',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'action_prompts',
                label: 'Action Prompts',
                desc: 'Use these nudges to prompt users to take an action',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'promotions',
                label: 'Promotions',
                desc: 'Use these nudges to cross-sell, upsell and show deals to users',
                promptsList: [],
                promptsLength: 0
            },
            {
                name: 'guides',
                label: 'Guides',
                desc: 'Use these nudges to help users learn and explore',
                promptsList: [],
                promptsLength: 0
            }
        ];
        this.templateToNameMap = {
            app_update: 'Action - 1',
            app_update_2: 'Action - 2',
            newsletter_subscription: 'Newsletter Subscription',
            yes_no_feedback: 'Yes/No feedback',
            net_promoter_score: 'Net promoter Score',
            rating_n_review: 'Rating & Review',
            multi_choice_questionnaire: 'Multi Choice Questionnaire',
            important_information: 'Alert - 1',
            important_information_2: 'Alert - 2',
            important_information_3: 'Alert - 3',
            // welcome_message: 'Welcome',
            tooltip_message: 'spotlight',
            tooltip_1: 'tooltip',
            tooltip_2: 'hotspot',
            tooltip_4: 'tooltip-4',
            user_feedback: 'User Feedback',
            welcome_message: 'Announcement - 1',
            new_feature_announcement: 'Announcement - 2',
            new_feature_announcement_2: 'Announcement - 3',
            new_feature_announcement_3: 'Announcement - 4',
            new_feature_announcement_4: 'Announcement - 5',
            personalised_deal: 'Promotion - 1',
            personalised_deal_2: 'Promotion - 2',
            upsell: 'Promotion - 3',
            cross_promote_products: 'Promotion - 4',
            download_app: 'Action',
            walkthroughs: 'Walkthroughs',
            get_started_checklist: 'Get Started Checklist',
            rating_with_user_feedback: 'Rating with User Feedback',
            nps_with_user_feedback: 'NPS with User Feedback',
            discover_features: 'Discover Features',
            promotional_videos: 'Promotional Videos',
            subscription_renewal_rate: 'Subscription Renewal',
            beta_test_signups: 'Beta Test Signups',
            welcome_message_html: 'Custom HTML',
            pnc_tooltip_html: 'Tooltip - Custom HTML',
            pnc_beacon_html: 'Beacon - Custom HTML',
            pnc_spotlight_html: 'Spotlight - Custom HTML',
            pnc_tooltip_1: 'Tooltip - Text',
            pnc_tooltip_2: 'Tooltip - Text, Button',
            pnc_tooltip_3: 'Tooltip - Text, Button, Image',
            pnc_tooltip_4: 'Tooltip - Text, Icon',
            pnc_tooltip_5: 'Tooltip - Text, Image on side',
            pnc_tooltip_6: 'Tooltip - Text, Button, Image on side',
            pnc_tooltip_7: 'Tooltip - Text, Image, Button, Steps',
            pnc_beacon_1: 'Beacon',
            pnc_beacon_2: 'Beacon - Text',
            pnc_beacon_3: 'Beacon - Text, Button',
            pnc_beacon_4: 'Beacon - Text, Button, Image',
            pnc_beacon_5: 'Beacon - Text, Image on side',
            pnc_beacon_6: 'Beacon - Text, Button, Image on side',
            pnc_spotlight_1: 'Spotlight',
            pnc_spotlight_2: 'Spotlight - Text',
            pnc_spotlight_3: 'Spotlight - Text, Button',
            pnc_spotlight_4: 'Spotlight - Text, Button, Image',
            pnc_spotlight_5: 'Spotlight - Text, Button, Image on side',
            pnc_tag_1: 'Tag - Text',
            fomo_tag_1: 'FOMO Tag - Text',
            fomo_tag_2: 'FOMO Tag - Text, Image on side'
        };
        this.nameToTemplateMap = {
            'Action - 1': 'app_update',
            'Action - 2': 'app_update_2',
            'Newsletter Subscription': 'newsletter_subscription',
            'Yes/No feedback': 'yes_no_feedback',
            'Net promoter Score': 'net_promoter_score',
            'Rating & Review': 'rating_n_review',
            'Multi Choice Questionnaire': 'multi_choice_questionnaire',
            'Alert - 1': 'important_information',
            'Alert - 2': 'important_information_2',
            'Alert - 3': 'important_information_3',
            'spotlight': 'tooltip_message',
            'tooltip': 'tooltip_1',
            'hotspot': 'tooltip_2',
            'tooltip-4': 'tooltip_4',
            'User Feedback': 'user_feedback',
            'Announcement - 1': 'welcome_message',
            'Announcement - 2': 'new_feature_announcement',
            'Announcement - 3': 'new_feature_announcement_2',
            'Announcement - 4': 'new_feature_announcement_3',
            'Announcement - 5': 'new_feature_announcement_4',
            'Promotion - 1': 'personalised_deal',
            'Promotion - 2': 'personalised_deal_2',
            'Promotion - 3': 'upsell',
            'Promotion - 4': 'cross_promote_products',
            'Action': 'download_app',
            'Walkthroughs': 'walkthroughs',
            'Get Started Checklist': 'get_started_checklist',
            'Rating with User Feedback': 'rating_with_user_feedback',
            'NPS with User Feedback': 'nps_with_user_feedback',
            'Discover Features': 'discover_features',
            'Promotional Videos': 'promotional_videos',
            'Subscription Renewal': 'subscription_renewal_rate',
            'Beta Test Signups': 'beta_test_signups',
            'Custom HTML': 'welcome_message_html',
            'Tooltip - Custom HTML': 'pnc_tooltip_html',
            'Beacon - Custom HTML': 'pnc_beacon_html',
            'Spotlight - Custom HTML': 'pnc_spotlight_html',
            'Tooltip - Text': 'pnc_tooltip_1',
            'Tooltip - Text, Button': 'pnc_tooltip_2',
            'Tooltip - Text, Button, Image': 'pnc_tooltip_3',
            'Tooltip - Text, Icon': 'pnc_tooltip_4',
            'Tooltip - Text, Image on side': 'pnc_tooltip_5',
            'Tooltip - Text, Button, Image on side': 'pnc_tooltip_6',
            'Tooltip - Text, Image, Button, Steps': 'pnc_tooltip_7',
            'Beacon': 'pnc_beacon_1',
            'Beacon - Text': 'pnc_beacon_2',
            'Beacon - Text, Button': 'pnc_beacon_3',
            'Beacon - Text, Button, Image': 'pnc_beacon_4',
            'Beacon - Text, Image on side': 'pnc_beacon_5',
            'Beacon - Text, Button, Image on side': 'pnc_beacon_6',
            'Spotlight': 'pnc_spotlight_1',
            'Spotlight - Text': 'pnc_spotlight_2',
            'Spotlight - Text, Button': 'pnc_spotlight_3',
            'Spotlight - Text, Button, Image': 'pnc_spotlight_4',
            'Spotlight - Text, Button, Image on side': 'pnc_spotlight_5',
            'Tag - Text': 'pnc_tag_1',
            'FOMO Tag - Text': 'fomo_tag_1',
            'FOMO Tag - Text, Image on side': 'fomo_tag_2',
        };
        this.templateToMinWidthMap = {
            web: {
                net_promoter_score: 30,
                nps_with_user_feedback: 30,
                rating_n_review: 30,
                multi_choice_questionnaire: 20,
                rating_with_user_feedback: 30,
                important_information: 30,
                important_information_2: 30,
                important_information_3: 30,
                user_feedback: 20,
                welcome_message: 20,
                new_feature_announcement: 20,
                new_feature_announcement_2: 20,
                new_feature_announcement_3: 20,
                new_feature_announcement_4: 20,
                personalised_deal: 20,
                personalised_deal_2: 20,
                upsell: 20,
                cross_promote_products: 20,
                pnc_tooltip_1: 6,
                pnc_tooltip_2: 6,
                pnc_tooltip_3: 6,
                pnc_tooltip_4: 6,
                pnc_beacon_1: 6,
                pnc_beacon_2: 6,
                pnc_beacon_3: 6,
                pnc_beacon_4: 6
            },
            mobile_web: {
                net_promoter_score: 80,
                nps_with_user_feedback: 80,
                rating_n_review: 80,
                multi_choice_questionnaire: 80,
                rating_with_user_feedback: 80,
                user_feedback: 80,
                important_information: 100,
                important_information_2: 100,
                important_information_3: 100,
                welcome_message: 30,
                new_feature_announcement: 30,
                new_feature_announcement_2: 30,
                new_feature_announcement_3: 30,
                new_feature_announcement_4: 30,
                personalised_deal: 40,
                personalised_deal_2: 50,
                upsell: 30,
                cross_promote_products: 30,
                pnc_tooltip_1: 20,
                pnc_tooltip_2: 20,
                pnc_tooltip_3: 20,
                pnc_tooltip_4: 20,
                pnc_beacon_1: 20,
                pnc_beacon_2: 20,
                pnc_beacon_3: 20,
                pnc_beacon_4: 20
            },
            android: {
                new_feature_announcement: 15,
                new_feature_announcement_2: 15,
                new_feature_announcement_3: 15,
                new_feature_announcement_4: 15
            },
            ios: {
                new_feature_announcement: 15,
                new_feature_announcement_2: 15,
                new_feature_announcement_3: 15,
                new_feature_announcement_4: 15
            }
        };
        this.nudgePropsCategory = {
            pnc_tooltip_1: {
                'web': {},
                'ios': {},
                'android': {}
            },
            pnc_tooltip_2: {
                'web': {
                    'btn1': 'Primary',
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            pnc_tooltip_3: {
                'web': {
                    'btn1': 'Primary',
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            pnc_tooltip_4: {
                'web': {
                    'label4': 'Title Text Editor',
                    'label5': 'Body Text Editor'
                },
                'ios': {},
                'android': {}
            },
            pnc_tooltip_5: {
                'web': {},
                'ios': {
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                },
                'android': {
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                }
            },
            pnc_tooltip_6: {
                'web': {},
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                }
            },
            pnc_tooltip_7: {
                'web': {
                    'label4': 'Title Text Editor',
                    'label5': 'Body Text Editor'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                }
            },
            pnc_beacon_1: {
                'web': {},
                'ios': {},
                'android': {}
            },
            pnc_beacon_2: {
                'web': {},
                'ios': {},
                'android': {}
            },
            pnc_beacon_3: {
                'web': {
                    'btn1': 'Primary',
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            pnc_beacon_4: {
                'web': {
                    'btn1': 'Primary',
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            pnc_beacon_5: {
                'web': {
                    'label4': 'Title Text Editor',
                    'label5': 'Body Text Editor'
                },
                'ios': {
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                },
                'android': {
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                }
            },
            pnc_beacon_6: {
                'web': {
                    'label4': 'Title Text Editor',
                    'label5': 'Body Text Editor'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                }
            },
            pnc_spotlight_1: {
                'web': {},
                'ios': {},
                'android': {}
            },
            pnc_spotlight_2: {
                'web': {},
                'ios': {},
                'android': {}
            },
            pnc_spotlight_3: {
                'web': {
                    'btn1': 'Primary',
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            pnc_spotlight_4: {
                'web': {
                    'btn1': 'Primary',
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            pnc_spotlight_5: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label5': 'Body Text Editor'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                    'label4': 'Title Text Editor',
                    'label6': 'Body Text Editor'
                }
            },
            welcome_message: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Primary'
                },
                'ios': {
                    'btn1': 'Primary'
                }
            },
            new_feature_announcement: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Primary'
                },
                'ios': {
                    'btn1': 'Primary'
                }
            },
            new_feature_announcement_2: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Primary'
                },
                'ios': {
                    'btn1': 'Primary'
                }
            },
            new_feature_announcement_3: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                }
            },
            new_feature_announcement_4: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                }
            },
            multi_choice_questionnaire: {
                'web': {
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            net_promoter_score: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Primary'
                },
                'ios': {
                    'btn1': 'Primary',
                    'btn2': 'Secondary'
                }
            },
            user_feedback: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            rating_n_review: {
                'web': {
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            rating_with_user_feedback: {
                'web': {
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            nps_with_user_feedback: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Primary'
                },
                'ios': {
                    'btn1': 'Primary',
                    'btn2': 'Secondary'
                }
            },
            newsletter_subscription: {
                'web': {
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            beta_test_signups: {
                'web': {
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            important_information: {
                'web': {},
                'ios': {},
                'android': {}
            },
            important_information_2: {
                'web': {
                    'btn1': 'Primary'
                },
                'android': {
                    'btn1': 'Primary',
                },
                'ios': {
                    'btn1': 'Primary',
                }
            },
            important_information_3: {
                'web': {},
                'ios': {},
                'android': {}
            },
            download_app: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'ios': {},
                'android': {}
            },
            app_update: {
                'web': {},
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            app_update_2: {
                'web': {},
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary'
                }
            },
            personalised_deal: {
                'web': {
                    'btn1': 'Primary',
                    'label1': 'Title Text Editor',
                    'label2': 'Body Text Editor 1',
                    'label3': 'Body Text Editor 2'
                },
                'android': {
                    'btn1': 'Primary',
                    'label1': 'Title Text Editor',
                    'label2': 'Body Text Editor 1',
                    'label3': 'Body Text Editor 2'
                },
                'ios': {
                    'btn1': 'Primary',
                    'label1': 'Title Text Editor',
                    'label2': 'Body Text Editor 1',
                    'label3': 'Body Text Editor 2'
                }
            },
            personalised_deal_2: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                }
            },
            upsell: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                }
            },
            cross_promote_products: {
                'web': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'android': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                },
                'ios': {
                    'btn1': 'Secondary',
                    'btn2': 'Primary',
                }
            }
        };
        this.templateWithImageAsFirst = {
            pnc_tooltip_3: 'pnc_tooltip_3',
            pnc_beacon_4: 'pnc_beacon_4',
            pnc_spotlight_4: 'pnc_spotlight_4',
            new_feature_announcement: 'new_feature_announcement',
            new_feature_announcement_3: 'new_feature_announcement_3',
            personalised_deal: 'personalised_deal'
        };
        this.templateForWhichBottomPaddingBeZero = {
            new_feature_announcement_2: 'new_feature_announcement_2',
            new_feature_announcement_4: 'new_feature_announcement_4',
            multi_choice_questionnaire: 'multi_choice_questionnaire'
        };
        this.templateNameToResultCategoryMap = {
            app_update: 'Button',
            app_update_2: 'Button',
            newsletter_subscription: 'Button',
            yes_no_feedback: 'Button',
            net_promoter_score: 'NPS',
            rating_n_review: 'Rating',
            multi_choice_questionnaire: 'Multi',
            important_information: 'Button',
            important_information_2: 'Button',
            welcome_message: 'Button',
            tooltip_message: 'View',
            tooltip_1: 'View',
            tooltip_2: 'View',
            tooltip_4: 'View',
            // user feedback now treated same as button
            user_feedback: 'Button',
            new_feature_announcement: 'Button',
            new_feature_announcement_2: 'Button',
            new_feature_announcement_3: 'Button',
            new_feature_announcement_4: 'Button',
            cross_promote_products: 'Button',
            upsell: 'Button',
            personalised_deal: 'Button',
            personalised_deal_2: 'Button',
            download_app: 'Button',
            walkthroughs: 'Special',
            get_started_checklist: 'Special',
            // rating_with_user_feedback: 'Special',
            // nps_with_user_feedback: 'Special',
            rating_with_user_feedback: 'Rating-with-user-feedback',
            nps_with_user_feedback: 'NPS-with-user-feedback',
            discover_features: 'View',
            promotional_videos: 'View',
            subscription_renewal_rate: 'Button',
            beta_test_signups: 'Button',
            pnc_tooltip_1: 'View',
            pnc_tooltip_2: 'Button',
            pnc_tooltip_3: 'Button',
            pnc_tooltip_4: 'View',
            pnc_tooltip_5: 'View',
            pnc_tooltip_6: 'Button',
            pnc_tooltip_7: 'Button',
            pnc_beacon_1: 'View',
            pnc_beacon_2: 'View',
            pnc_beacon_3: 'Button',
            pnc_beacon_4: 'Button',
            pnc_beacon_5: 'View',
            pnc_beacon_6: 'Button',
            pnc_spotlight_1: 'View',
            pnc_spotlight_2: 'View',
            pnc_spotlight_3: 'Button',
            pnc_spotlight_4: 'Button',
            pnc_spotlight_5: 'Button',
            fomo_tag_1: 'View'
        };
        this.templateNameToPromptTypeMap = {
            master_template: 'prompt',
            app_update: 'prompt',
            app_update_2: 'prompt',
            newsletter_subscription: 'prompt',
            yes_no_feedback: 'prompt',
            net_promoter_score: 'prompt',
            rating_n_review: 'prompt',
            multi_choice_questionnaire: 'prompt',
            important_information: 'prompt',
            important_information_2: 'prompt',
            important_information_3: 'prompt',
            welcome_message: 'prompt',
            user_feedback: 'prompt',
            new_feature_announcement: 'prompt',
            new_feature_announcement_2: 'prompt',
            new_feature_announcement_3: 'prompt',
            new_feature_announcement_4: 'prompt',
            cross_promote_products: 'prompt',
            upsell: 'prompt',
            personalised_deal: 'prompt',
            personalised_deal_2: 'prompt',
            download_app: 'prompt',
            walkthroughs: 'prompt',
            get_started_checklist: 'prompt',
            rating_with_user_feedback: 'prompt',
            nps_with_user_feedback: 'prompt',
            discover_features: 'prompt',
            promotional_videos: 'prompt',
            subscription_renewal_rate: 'prompt',
            beta_test_signups: 'prompt',
            welcome_message_html: 'prompt',
            pnc_tooltip_html: 'point-and-click-prompt',
            pnc_beacon_html: 'point-and-click-prompt',
            pnc_spotlight_html: 'point-and-click-prompt',
            pnc_tooltip_1: 'point-and-click-prompt',
            pnc_tooltip_2: 'point-and-click-prompt',
            pnc_tooltip_3: 'point-and-click-prompt',
            pnc_tooltip_4: 'point-and-click-prompt',
            pnc_tooltip_5: 'point-and-click-prompt',
            pnc_tooltip_6: 'point-and-click-prompt',
            pnc_tooltip_7: 'point-and-click-prompt',
            pnc_beacon_1: 'point-and-click-prompt',
            pnc_beacon_2: 'point-and-click-prompt',
            pnc_beacon_3: 'point-and-click-prompt',
            pnc_beacon_4: 'point-and-click-prompt',
            pnc_beacon_5: 'point-and-click-prompt',
            pnc_beacon_6: 'point-and-click-prompt',
            pnc_spotlight_1: 'point-and-click-prompt',
            pnc_spotlight_2: 'point-and-click-prompt',
            pnc_spotlight_3: 'point-and-click-prompt',
            pnc_spotlight_4: 'point-and-click-prompt',
            pnc_spotlight_5: 'point-and-click-prompt',
            pnc_tag_1: 'point-and-click-prompt',
            fomo_tag_1: 'point-and-click-prompt',
            fomo_tag_2: 'point-and-click-prompt'
        };
        this.labelsMap = {
            prom_count: 'Promoters',
            pass_count: 'Passive',
            detr_count: 'Detractors',
            prom_ccount: 'Promoters',
            pass_ccount: 'Passive',
            detr_ccount: 'Detractors',
            star10_per: '10 Star',
            star9_per: '9 Star',
            star8_per: '8 Star',
            star7_per: '7 Star',
            star6_per: '6 Star',
            star5_per: '5 Star',
            star4_per: '4 Star',
            star3_per: '3 Star',
            star2_per: '2 Star',
            star1_per: '1 Star'
        };
        this.inputFieldTemplatesMap = {
            beta_test_signups: 'beta_test_signups',
            user_feedback: 'user_feedback',
            newsletter_subscription: 'newsletter_subscription',
            net_promoter_score: 'net_promoter_score',
            rating_n_review: 'rating_n_review',
            multi_choice_questionnaire: 'multi_choice_questionnaire',
            nps_with_user_feedback: 'nps_with_user_feedback',
            rating_with_user_feedback: 'rating_with_user_feedback'
        };
        // TODO: remove this once fix is done from sdk side
        this.hideBorderRadiusPromptMap = {
            new_feature_announcement: 'new_feature_announcement',
            new_feature_announcement_3: 'new_feature_announcement_3',
            pnc_tooltip_3: 'pnc_tooltip_3',
            pnc_beacon_4: 'pnc_beacon_4',
            pnc_spotlight_4: 'pnc_spotlight_4',
            personalised_deal: 'personalised_deal',
            promotional_videos: 'promotional_videos'
        };
        this.defaultFont = {
            name: 'App Default',
            value: 'app-default',
            desc: 'Your App default font will be picked'
        };
        /* these prompts min-width in ios and android should be 80% */
        // minWidthExceptions = [
        //   'newsletter_subscription',
        //   'user_feedback',
        //   'net_promoter_score',
        //   'nps_with_user_feedback',
        //   'rating_n_review',
        //   'rating_with_user_feedback'
        // ];
        this.scaleValueMap = {
            prompt: {
                spacing: 'spacing',
                btnContainerSpacing: 'btnContainerSpacing',
                btnGap: 'btnGap',
            },
            label0: {
                fontSize: 'fontSize',
                spacing: 'spacing'
            },
            label1: {
                fontSize: 'fontSize',
                spacing: 'spacing'
            },
            label2: {
                fontSize: 'fontSize',
                spacing: 'spacing'
            },
            label3: {
                fontSize: 'fontSize',
                spacing: 'spacing'
            },
            label4: {
                fontSize: 'fontSize'
            },
            label6: {
                fontSize: 'fontSize'
            },
            img1: {
                spacing: 'spacing'
            },
            input1: {
                fontSize: 'fontSize',
                spacing: 'spacing'
            },
            h_card: {
                gap: 'gap',
                spacing: 'spacing'
            },
            btn1: {
                fontSize: 'fontSize',
                height: 'height'
            },
            btn2: {
                fontSize: 'fontSize',
                height: 'height'
            },
            'btnX-new': {
                spacing: 'spacing',
                fontSize: 'fontSize',
                iconSize: 'iconSize',
                bgSize: 'bgSize'
            },
            nps: {
                fontSize: 'fontSize',
                height: 'height',
                spacing: 'spacing'
            },
            multiChoice: {
                fontSize: 'fontSize',
                labelGap: 'labelGap',
                optionSpacing: 'optionSpacing',
                spacing: 'spacing'
            },
            rating: {
                dimension: 'dimension',
                gap: 'gap',
                spacing: 'spacing'
            },
            ratingInputLabel: {
                spacing: 'spacing',
                fontSize: 'fontSize'
            },
            npsInputLabel: {
                spacing: 'spacing',
                fontSize: 'fontSize'
            },
            'col-container': {
                spacing: 'spacing',
                columns: 'columns'
            },
            label5: {
                spacing: 'spacing',
                fontSize: 'fontSize'
            },
        };
        this.maxValuesOfProps = {
            prompt: {
                spacing: 24,
                btnGap: 16,
            },
            label0: {
                spacing: 24
            },
            label1: {
                spacing: 24
            },
            label2: {
                spacing: 8
            },
            label3: {
                spacing: 6
            },
            input1: {
                spacing: 16
            },
            h_card: {
                gap: 16,
                spacing: 24
            },
            'btnX-new': {
                spacing: 10,
                fontSize: 18,
                iconSize: 10
            },
            nps: {
                fontSize: 12,
                height: 34,
                spacing: 24
            },
            multiChoice: {
                labelGap: 16,
                optionSpacing: 8
            },
            rating: {
                dimension: 32,
                gap: 0,
                spacing: 24
            },
            btn1: {
                height: 44
            },
            btn2: {
                height: 44
            },
            ratingInputLabel: {
                spacing: 32
            },
            npsInputLabel: {
                spacing: 32
            },
            'col-container': {
                spacing: 24
            },
            label5: {
                spacing: 24
            }
        };
        this.requiredPropsForElement = {
            btn1: {
                text: 'text'
            },
            btn2: {
                text: 'text'
            },
            label0: {
                text: 'text'
            },
            label1: {
                text: 'text'
            },
            label2: {
                text: 'text'
            },
            label3: {
                text: 'text'
            },
            label4: {
                text: 'text'
            },
            label5: {
                text: 'text'
            },
            label6: {
                text: 'text'
            },
            npsInputLabel: {
                text: 'text'
            },
            ratingInputLabel: {
                text: 'text'
            }
        };
        this.defaultValueOfBtnXBelowFiftyPercent = {
            fontSize: 9,
            bgSize: 10,
            iconSize: 5,
            fontWidth: 1
        };
        this.templateMismatchMap = {
            'web': {
                'multi_choice_questionnaire': {
                    'previousSubmit': 'btn1',
                    'newSubmit': 'btn2'
                },
                'user_feedback': {
                    'previousSubmit': 'btn1',
                    'newSubmit': 'btn2'
                },
                'rating_n_review': {
                    'previousSubmit': 'btn1',
                    'newSubmit': 'btn2'
                },
                'newsletter_subscription': {
                    'previousSubmit': 'btn1',
                    'newSubmit': 'btn2'
                },
                'beta_test_signups': {
                    'previousSubmit': 'btn1',
                    'newSubmit': 'btn2'
                }
            },
            'ios': {
                'net_promoter_score': {
                    'previousSubmit': 'btn2',
                    'newSubmit': 'btn1'
                },
                'nps_with_user_feedback': {
                    'previousSubmit': 'btn2',
                    'newSubmit': 'btn1'
                }
            }
        };
        this.labelRightSpacingNameMap = {
            pnc_tooltip_1: 'label1',
            pnc_tooltip_2: 'label1',
            pnc_tooltip_3: 'label1',
            pnc_beacon_2: 'label1',
            pnc_beacon_3: 'label1',
            pnc_beacon_4: 'label1',
            pnc_spotlight_2: 'label1',
            pnc_spotlight_3: 'label1',
            pnc_spotlight_4: 'label1',
            welcome_message: 'label1',
            new_feature_announcement: 'label1',
            new_feature_announcement_2: 'label0',
            new_feature_announcement_3: 'label1',
            new_feature_announcement_4: 'label0',
            download_app: 'label1',
            multi_choice_questionnaire: 'label1',
            net_promoter_score: 'label1',
            nps_with_user_feedback: 'label1',
            user_feedback: 'label1',
            rating_n_review: 'label1',
            rating_with_user_feedback: 'label1',
            newsletter_subscription: 'label1',
            beta_test_signups: 'label1',
            personalised_deal: 'label1',
            upsell: 'label1',
            cross_promote_products: 'label1',
        };
        this.analyticsProviderNameMap = {
            mxp: 'Mixpanel',
            ctp: 'Clevertap',
            amp: 'Amplitude',
            ga: 'Google Analytics',
            smt: 'Smartech Events',
            fbs: 'Firebase',
            omni: 'Omniture',
            loca: 'Localytics',
            wbe: 'Webengage',
            hsl: 'Hansel Events',
            sgmt: 'Segment'
        };
        this.labelRightSpacingTemplateNameMap = {
            'DESKTOP': {
                'upsell': 'upsell',
                'cross_promote_products': 'cross_promote_products'
            }
        };
        this.lableRightSpacingMinWidthValueMap = {
            'DESKTOP': {
                'upsell': 30,
                'cross_promote_products': 30
            }
        };
        this.delayVersionMap = {
            'android': '8.5.2',
            'ios': '8.5.1',
            'web': '8.4.0'
        };
        this.feedbackNudgeMap = {
            multi_choice_questionnaire: 'multi_choice_questionnaire',
            net_promoter_score: 'net_promoter_score',
            user_feedback: 'user_feedback',
            rating_n_review: 'rating_n_review',
            rating_with_user_feedback: 'rating_with_user_feedback',
            nps_with_user_feedback: 'nps_with_user_feedback'
        };
        this.submitBtnNudgeMap = {
            multi_choice_questionnaire: 'multi_choice_questionnaire',
            net_promoter_score: 'net_promoter_score',
            user_feedback: 'user_feedback',
            rating_n_review: 'rating_n_review',
            rating_with_user_feedback: 'rating_with_user_feedback',
            nps_with_user_feedback: 'nps_with_user_feedback',
            newsletter_subscription: 'newsletter_subscription',
            beta_test_signups: 'beta_test_signups'
        };
        this.masterTemplate = {};
        this.customizeAndNotificationFlag = {
            customize: false,
            navigate: false
        };
        this.mapOfHiddenEventsForGoal = {
            '_hsl_onAppLoad': '_hsl_onAppLoad',
            'Nudge branch tracker': 'Nudge branch tracker',
            'app_updated': 'app_updated',
            'first_app_launched': 'first_app_launched',
            'regular_app_launched': 'regular_app_launched',
            'app_crashed': 'app_crashed',
            'app_reinstalled': 'app_reinstalled',
            'pn_token_generated': 'pn_token_generated',
            'pn_token_failed': 'pn_token_failed',
            'pn_token_refreshed': 'pn_token_refreshed',
            'device_updated': 'device_updated',
            'app_location_enabled': 'app_location_enabled',
            'app_location_disabled': 'app_location_disabled',
            'pn_delivered': 'pn_delivered',
            'pn_clicked': 'pn_clicked',
            'pn_dismissed': 'pn_dismissed',
            'inapp_viewed': 'inapp_viewed',
            'inapp_clicked': 'inapp_clicked',
            'inapp_closed': 'inapp_closed',
            'inbox_delivered': 'inbox_delivered',
            'inbox_viewed': 'inbox_viewed',
            'inbox_clicked': 'inbox_clicked',
            'inbox_dismissed': 'inbox_dismissed',
            'user_logged_in': 'user_logged_in',
            'user_logged_out': 'user_logged_out',
            'user_enabled_pn': 'user_enabled_pn',
            'user_disabled_pn': 'user_disabled_pn',
            'user_tracking_opt_in': 'user_tracking_opt_in',
            'user_tracking_opt_out': 'user_tracking_opt_out',
            'user_pn_opt_in': 'user_pn_opt_in',
            'user_pn_opt_out': 'user_pn_opt_out',
            'user_inapp_opt_in': 'user_inapp_opt_in',
            'user_inapp_opt_out': 'user_inapp_opt_out',
            'user_profile_push': 'user_profile_push',
            'hansel_nudge_event': 'hansel_nudge_event'
        };
        this.mapOfNudgesWithImgOnSide = {
            pnc_tooltip_5: 'pnc_tooltip_5',
            pnc_tooltip_6: 'pnc_tooltip_6',
            pnc_tooltip_7: 'pnc_tooltip_7',
            pnc_beacon_5: 'pnc_beacon_6',
            pnc_beacon_6: 'pnc_beacon_6',
            pnc_spotlight_5: 'pnc_spotlight_5',
            important_information_3: 'important_information_3'
        };
        this.mapOfPNCNudgeWithSecondaryBtn = {
            pnc_tooltip_6: 'pnc_tooltip_6',
            pnc_tooltip_7: 'pnc_tooltip_7',
            pnc_beacon_6: 'pnc_beacon_6',
            pnc_spotlight_4: 'pnc_spotlight_4',
            pnc_spotlight_5: 'pnc_spotlight_5'
        };
        this.userAgentStringForMobileDevice = "Mozilla/5.0 (Linux; Android 10; SM-G981B) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.162 Mobile Safari/537.36";
        this.mapOfHiddneInternalEvents = {
            'hansel_nudge_event': 'hansel_nudge_event'
        };
        this.htmlNudges = {
            welcome_message_html: 'welcome_message_html',
            pnc_tooltip_html: 'pnc_tooltip_html',
            pnc_beacon_html: 'pnc_beacon_html',
            pnc_spotlight_html: 'pnc_spotlight_html'
        };
        this.mapOfNudgesWithImgOnTopOrBottom = {
            pnc_spotlight_4: 'pnc_spotlight_4'
        };
        this.btnObject = {
            "type": "button",
            "props": {
                "text": "GOT IT",
                "htmlText": "<span class=\"textColor\" style=\"color: #ffffff;\">GOT IT</span>",
                "textColor": "#03A9F3",
                "fontSize": 9,
                "fontStyle": "R",
                "fontFamily": "app-default",
                "bgColor": "",
                "type": "flat",
                "height": "20px",
                "imgName": "",
                "actionType": "generic",
                "btnAlign": "auto",
                "spacing": "6px 6px 6px 6px"
            },
            "actions": {
                "onHover": [],
                "onClick": []
            }
        };
        this.raiseContentChangeEvent = throttle(function () {
            _this.contentChangeDate.next();
        }, 500, { 'leading': false, 'trailing': true });
        this.raiseTriggerPromptData = debounce(function (data) {
            if (data === void 0) { data = null; }
            _this.triggerPromptData.next(data);
        });
        this.validateOnChange = debounce(function (data) {
            var promptData = data.promptData, requiredPropsForElement = data.requiredPropsForElement, elementType = data.elementType;
            _this.checkForErrorInElement(promptData, requiredPropsForElement, elementType);
            if (requiredPropsForElement[elementType].isError) {
                _this.requiredValueError.next(true);
                return;
            }
            var keys = Object.keys(requiredPropsForElement);
            var elementForWhichErrorFlagTrue = keys.filter(function (key) { return requiredPropsForElement[key].isError; });
            _this.requiredValueError.next(elementForWhichErrorFlagTrue.length ? true : false);
        }, 100);
        this.triggerViewElementChange = debounce(function () {
            _this.viewElementChange.next();
        }, 1000);
        this.triggerElementSelectionChange = debounce(function (data) {
            _this.elementSelectionChange.next(data);
        }, 100);
        this.setSelectedNodeFromViewHierarchy = debounce(function (node) {
            _this.selectedNodeChangeFromHierarchy.next(node);
        }, 100);
        this.triggerViewHierarchyFlag = debounce(function (flag) {
            _this.changeInViewHierarchyFlag.next(flag);
        }, 100);
        this.closeViewHierarchyDialog = debounce(function (flag) {
            _this.closeViewHierarchyDialogFlag.next(flag);
        }, 100);
        this.clickToReposition = function (changes, os) {
            var props = changes['prompt'].props;
            props['element_identifier'] = '';
            var payload = {
                userAgentStr: navigator.userAgent
            };
            if (os === 'web') {
                if (props['view'] === 'MOBILE') {
                    payload.userAgentStr = _this.userAgentStringForMobileDevice;
                }
                _this.sendDataToExtension(payload);
                _this.triggerReposition();
                return;
            }
            props['pos_x'] = 0;
            props['pos_y'] = 0;
        };
        this.raiseCaptureBtnClickEvent = debounce(function () {
            _this.webPncCaptureBtnClickEvent.next();
        }, 100);
        this.raiseCaptureCompleteEvent = debounce(function () {
            _this.webPncCaptureCompleteEvent.next();
        }, 100);
        this.raiseTriggerPromptData = this.raiseTriggerPromptData.bind(this);
        this.objectObservable = this.objectObservable.bind(this);
        this.initCustomizeAndNotificationToastFlagFromStorage();
    }
    EditorCommonService.prototype.initCustomizeAndNotificationToastFlagFromStorage = function () {
        var selectedFlagFromLocalStorage = JSON.parse(localStorage.getItem('customizeAndNotificationFlag'));
        if (selectedFlagFromLocalStorage) {
            this.customizeAndNotificationFlag = tslib_1.__assign({}, selectedFlagFromLocalStorage);
        }
    };
    EditorCommonService.prototype.getNudgePropsCategory = function (nudge) {
        return this.nudgePropsCategory[nudge] || {};
    };
    EditorCommonService.prototype.getTemplateToMinWidthMap = function (os) {
        return this.templateToMinWidthMap[os];
    };
    EditorCommonService.prototype.getPromptsWithImageAsFirst = function () {
        return this.templateWithImageAsFirst;
    };
    EditorCommonService.prototype.getTemplateMismatchMap = function (os) {
        return this.templateMismatchMap[os];
    };
    EditorCommonService.prototype.setCustomizeFlag = function () {
        this.customizeAndNotificationFlag.customize = true;
        localStorage.setItem('customizeAndNotificationFlag', JSON.stringify(this.customizeAndNotificationFlag));
    };
    EditorCommonService.prototype.setNavigateFlag = function () {
        this.customizeAndNotificationFlag.navigate = true;
        localStorage.setItem('customizeAndNotificationFlag', JSON.stringify(this.customizeAndNotificationFlag));
    };
    EditorCommonService.prototype.getFlagForNavigateAndCustomizeNotification = function () {
        return this.customizeAndNotificationFlag;
    };
    EditorCommonService.prototype.getActionsList = function (appId) {
        var url = "/dashboard/actions/v1/" + appId + "/";
        return this.http.get(url).pipe(map(function (res) {
            var body = res;
            return body || {};
        }));
    };
    EditorCommonService.prototype.getMinWidthExceptions = function () {
        return this.inputFieldTemplatesMap;
    };
    EditorCommonService.prototype.getMapOfPromptsWhoseBorderRadiusBeHidden = function () {
        return this.hideBorderRadiusPromptMap;
    };
    EditorCommonService.prototype.getScaledValueMap = function (os, template) {
        var scaleValue = cloneDeep(this.scaleValueMap);
        if (os !== 'ios') {
            scaleValue['btn1']['spacing'] = 'spacing';
            scaleValue['btn2']['spacing'] = 'spacing';
        }
        if (os !== 'web' && this.mapOfNudgesWithImgOnSide.hasOwnProperty(template)) {
            scaleValue['label4']['spacing'] = 'spacing';
            if (template !== 'important_information_3') {
                scaleValue['label6']['spacing'] = 'spacing';
            }
        }
        if (os === 'web') {
            scaleValue['btn1']['spacing'] = 'spacing';
            scaleValue['btn2']['spacing'] = 'spacing';
            scaleValue['btn1']['btnSpacing'] = 'btnSpacing';
            scaleValue['btn2']['btnSpacing'] = 'btnSpacing';
        }
        return scaleValue;
    };
    EditorCommonService.prototype.getMaxValueOfProps = function (os, nudge) {
        var maxValueObj = cloneDeep(this.maxValuesOfProps);
        if (os === 'web') {
            maxValueObj['btn1']['spacing'] = 16;
            maxValueObj['btn2']['spacing'] = 16;
            maxValueObj['btn1']['btnSpacing'] = 16;
            maxValueObj['btn2']['btnSpacing'] = 16;
            maxValueObj['rating']['gap'] = 12;
            maxValueObj['nps']['fontSize'] = 14;
            if (nudge.changes.prompt.props.view === WebView.DESKTOP) {
                maxValueObj['rating']['dimension'] = 48;
            }
            else {
                maxValueObj['rating']['dimension'] = 42;
            }
        }
        if (os === 'android') {
            maxValueObj['btn1']['spacing'] = 24;
            maxValueObj['btn2']['spacing'] = 24;
        }
        return maxValueObj;
    };
    EditorCommonService.prototype.returnHanselNudgeEvent = function (ipaValue) {
        if (ipaValue === void 0) { ipaValue = false; }
        return {
            av: '',
            id: '',
            internal: false,
            ipa: ipaValue,
            name: 'hansel_nudge_event',
            nameAlias: 'hansel_nudge_event',
            ven: 'hsl',
            attrs: [
                { type: 'string', id: 'nudge_name' },
                { type: 'string', id: 'user_id' },
                { type: 'string', id: 'nudge_action' },
                { type: 'number', id: 'time_spent_nudge' }
            ]
        };
    };
    EditorCommonService.prototype.returnAppLaunchEventForAI = function () {
        return {
            av: '',
            id: '',
            internal: false,
            ipa: true,
            name: '_hsl_onAppLoad',
            nameAlias: '_hsl_onAppLoad',
            ven: 'hsl',
            attrs: [
                { id: 'app_version', type: 'string' },
                { id: 'sdk_version', type: 'string' },
                { id: 'os_version', type: 'string' },
                { id: 'Type', type: 'string' },
                { id: 'device_model', type: 'string' },
                { id: 'device_language', type: 'string' },
                { id: 'user_id', type: 'string' },
                { id: 'timestamp', type: 'number' }
            ]
        };
    };
    EditorCommonService.prototype.returnPageLoadEventForAI = function () {
        return {
            av: '',
            id: '',
            internal: false,
            ipa: true,
            name: '_hsl_page_load',
            nameAlias: '_hsl_page_load',
            ven: 'hsl',
            attrs: [
                { id: 'app_version', type: 'string' },
                { id: 'sdk_version', type: 'string' },
                { id: 'os_version', type: 'string' },
                { id: 'screen_name', type: 'string' },
                { id: 'device_model', type: 'string' },
                { id: 'device_language', type: 'string' },
                { id: 'user_id', type: 'string' },
                { id: 'timestamp', type: 'number' }
            ]
        };
    };
    EditorCommonService.prototype.returnPageLoadEvent = function (os, ipaValue) {
        if (ipaValue === void 0) { ipaValue = false; }
        var attrs = [{ type: 'string', id: 'url' }];
        if (os === 'web') {
            attrs = [
                { id: 'page_url', type: 'string' },
                { id: 'browser', type: 'string' },
                { id: 'browser_language', type: 'string' },
                { id: 'platform', type: 'string' },
                { id: 'User_id', type: 'string' },
                { id: 'sdk_version', type: 'string' },
                { id: 'os', type: 'string' },
                { id: 'Timestamp', type: 'number' },
                { id: 'utm_source', type: 'string' },
                { id: 'utm_medium', type: 'string' },
                { id: 'utm_campaign', type: 'string' },
                { id: 'query_parameters', type: 'string' }
            ];
        }
        return {
            av: '',
            id: '',
            internal: false,
            ipa: ipaValue,
            name: '_hsl_page_load',
            nameAlias: '_hsl_page_load',
            ven: 'hsl',
            attrs: attrs
        };
    };
    EditorCommonService.prototype.formatText = function (formatType, json, property) {
        var index = json[property].indexOf(formatType);
        var newStr;
        if (index > -1) {
            newStr = json[property].split('');
            newStr.splice(index, 1);
            newStr = newStr.join('');
            json[property] = newStr;
        }
        else {
            json[property] = json[property] + formatType;
        }
    };
    EditorCommonService.prototype.returnThePositioningStyle = function (position, promptData) {
        var styleObj = {};
        if (position === 'ML' || position === 'MR') {
            styleObj['top'] = "calc(50% - " + promptData.prompt.props.margin / 2 + "px)";
            // tslint:disable-next-line: max-line-length
            styleObj['transform'] = "translateY(calc(-50% - " + promptData.prompt.props.margin / 2 + "px))";
            return styleObj;
        }
        if (position !== 'MC' && position !== 'TC' && position !== 'BC') {
            return {};
        }
        styleObj['left'] = "calc(50% - " + promptData.prompt.props.margin / 2 + "px)";
        if (position === 'MC') {
            styleObj['top'] = "calc(50% - " + promptData.prompt.props.margin / 2 + "px)";
            // tslint:disable-next-line: max-line-length
            styleObj['transform'] = "translate(calc(-50% - " + promptData.prompt.props.margin / 2 + "px), calc(-50% - " + promptData.prompt.props.margin / 2 + "px))";
        }
        else {
            styleObj['transform'] = "translate(calc(-50% - " + promptData.prompt.props.margin / 2 + "px))";
        }
        return styleObj;
    };
    EditorCommonService.prototype.getHotspotOption = function () {
        return this.hotspotOptions;
    };
    EditorCommonService.prototype.getSpotlightOption = function () {
        return this.spotlightOptions;
    };
    EditorCommonService.prototype.isFormatTextPropertySelected = function (currentFormats, formatType) {
        if (currentFormats &&
            formatType &&
            currentFormats.indexOf(formatType) > -1) {
            return true;
        }
        return false;
    };
    EditorCommonService.prototype.generateDeviceID = function () {
        function s(n) {
            return h((Math.random() * (1 << (n << 2))) ^ Date.now()).slice(-n);
        }
        function h(n) {
            return (n | 0).toString(16);
        }
        return [
            s(4) + s(4),
            s(4),
            '4' + s(3),
            h(8 | (Math.random() * 4)) + s(3),
            // s(4) + s(4) + s(4),
            Date.now()
                .toString(16)
                .slice(-10) + s(2) // Use timestamp to avoid collisions
        ].join('');
    };
    EditorCommonService.prototype.getTemplateToNameMap = function () {
        return this.templateToNameMap;
    };
    EditorCommonService.prototype.getTemplateNameToResultCategoryMap = function () {
        return this.templateNameToResultCategoryMap;
    };
    EditorCommonService.prototype.getLabelsMap = function () {
        return this.labelsMap;
    };
    EditorCommonService.prototype.getFontsList = function (os) {
        switch (os) {
            case 'ios':
                return this.iosFonts;
            case 'android':
                return this.androidFonts;
            case 'web':
                return this.webFonts;
            default:
                return this.webFonts;
        }
    };
    EditorCommonService.prototype.returnTheHiddenListForTrigger = function (triggerName) {
        switch (triggerName) {
            // case '_hsl_onAppLoad': return ['Type'];
            case 'hansel_nudge_event': return ['nudge_name'];
            default: return [];
        }
    };
    EditorCommonService.prototype.getDefaultFont = function () {
        return this.defaultFont;
    };
    EditorCommonService.prototype.isDefaultFontSelected = function (fontSelected) {
        return fontSelected === this.defaultFont['value'];
    };
    EditorCommonService.prototype.getPositions = function () {
        return this.positions;
    };
    EditorCommonService.prototype.getPromptTypeFromPromptName = function (promptName) {
        return this.templateNameToPromptTypeMap[promptName];
    };
    EditorCommonService.prototype.getImage = function (imageUrl) {
        return this.http.get(imageUrl, { responseType: 'blob' });
    };
    EditorCommonService.prototype.getInputTempBtnText = function (templateName, properties, isButtonX) {
        var txt = '';
        if (this.inputFieldTemplatesMap.hasOwnProperty(templateName) &&
            (properties.actionType === 'submit' || properties.actionType === 'cancel')) {
            txt = properties.actionType === 'submit' ? 'Submit' : 'Cancel';
        }
        return txt;
    };
    EditorCommonService.prototype.hexToRgbA = function (hex, opacity) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            // tslint:disable-next-line:no-bitwise
            return ('rgba(' +
                [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
                ',' +
                opacity +
                ')');
        }
        return hex;
    };
    EditorCommonService.prototype.getVerticalPosition = function (position) {
        if (position.includes('M')) {
            return 'interstitial';
        }
        else if (position.includes('B')) {
            return 'footer';
        }
        else {
            return 'header';
        }
    };
    EditorCommonService.prototype.setPromptWidthData = function () {
        this.promptWidthData.next();
    };
    // check
    EditorCommonService.prototype.triggerReposition = function () {
        this.repositionChange.next();
    };
    EditorCommonService.prototype.raiseCornerRadiusChangeEvent = function () {
        this.cornerRadiusDataChange.next();
    };
    EditorCommonService.prototype.triggerSpotlightChange = function () {
        this.spolightData.next();
    };
    EditorCommonService.prototype.triggerSelectedElementChange = function (data) {
        this.selectedElementData.next(data);
    };
    EditorCommonService.prototype.removeWhiteSpace = function (text) {
        return text.replace(/\s/g, function (match) {
            // replace only spaces
            if (match.charCodeAt(0) === 32) {
                return ' ';
            }
            return match;
        });
    };
    EditorCommonService.prototype.parseVisualizerLabelTxt = function (txtProps, txtPropName, shouldShowText) {
        if (txtPropName === void 0) { txtPropName = null; }
        if (shouldShowText === void 0) { shouldShowText = false; }
        var labelTxt = txtProps.htmlText || txtProps.text;
        if (shouldShowText) {
            labelTxt = txtProps.text;
        }
        for (var key in txtProps.textVariables) {
            if (txtProps.textVariables.hasOwnProperty(key)) {
                labelTxt = labelTxt.replaceAll("{{" + key + "}}", txtProps.textVariables[key][txtPropName || 'fallback']);
            }
        }
        return labelTxt;
    };
    EditorCommonService.prototype.objectObservable = function (watchableObj, onChange) {
        var proxyObject = {
            set: function (target, key, value, receiver) {
                // if the value did not change do not raise event.
                if (target[key] !== value) {
                    onChange({ key: key, value: value });
                }
                return Reflect.set(target, key, value, receiver);
            },
            get: function (target, key, receiver) {
                if (typeof target[key] === 'object' && target[key] !== null) {
                    return new Proxy(target[key], proxyObject);
                }
                return Reflect.get(target, key, receiver);
            }
        };
        return new Proxy(watchableObj, proxyObject);
    };
    EditorCommonService.prototype.listenForObjectKeys = function (watchableObj, onChange) {
        var proxyObject = {
            defineProperty: function (target, propertyKey, attributes) {
                onChange(true);
                return Reflect.defineProperty(target, propertyKey, attributes);
            },
            deleteProperty: function (target, key) {
                if (!(key in target)) {
                    return false;
                }
                onChange(true);
                return Reflect.deleteProperty(target, key);
            }
        };
        return new Proxy(watchableObj, proxyObject);
    };
    EditorCommonService.prototype.checkForErrorInElement = function (promptData, requiredPropsForElement, elementKey) {
        var keys = Object.keys(requiredPropsForElement[elementKey]);
        var flag = false;
        keys.forEach(function (key) {
            var keyVal = promptData[elementKey]['props'][key] ? promptData[elementKey]['props'][key].trim() : promptData[elementKey]['props'][key];
            if (!keyVal && key !== 'isError') {
                flag = true;
            }
        });
        requiredPropsForElement[elementKey].isError = flag;
    };
    EditorCommonService.prototype.filterRequiredElementKeysBasedOnNudge = function (promptData, requiredPropsForElement) {
        var _this = this;
        var keys = Object.keys(requiredPropsForElement);
        keys.forEach(function (key) {
            if (!promptData.hasOwnProperty(key)) {
                delete requiredPropsForElement[key];
            }
            else {
                _this.checkForErrorInElement(promptData, requiredPropsForElement, key);
            }
        });
    };
    EditorCommonService.prototype.validationOfRequiredProps = function (promptData, elementType, watchableObj, validateOnChange) {
        if (!this.requiredPropsForElement.hasOwnProperty(elementType)) {
            return watchableObj;
        }
        var requiredPropsForElement = cloneDeep(this.requiredPropsForElement);
        this.filterRequiredElementKeysBasedOnNudge(promptData, requiredPropsForElement);
        if (!Object.keys(requiredPropsForElement).length) {
            return watchableObj;
        }
        var proxyObject = {
            set: function (target, key, value, receiver) {
                if (requiredPropsForElement[elementType].hasOwnProperty(key)) {
                    validateOnChange({ promptData: promptData, requiredPropsForElement: requiredPropsForElement, elementType: elementType });
                }
                return Reflect.set(target, key, value, receiver);
            },
            get: function (target, key, receiver) {
                if (typeof target[key] === 'object' && target[key] !== null) {
                    return new Proxy(target[key], proxyObject);
                }
                return Reflect.get(target, key, receiver);
            }
        };
        return new Proxy(watchableObj, proxyObject);
    };
    EditorCommonService.prototype.isColorlightOrDark = function (color) {
        // Variables for red, green, blue values
        var r, g, b, hsp;
        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
            // If HEX --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            r = color[1];
            g = color[2];
            b = color[3];
        }
        else {
            // If RGB --> Convert it to HEX: http://gist.github.com/983661
            color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
        }
        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b));
        // Using the HSP value, determine whether the color is light or dark
        if (hsp > 127.5) {
            return 'light';
        }
        else {
            return 'dark';
        }
    };
    EditorCommonService.prototype.getPromptBtnCounts = function (nudgeKeys) {
        var btnCountArr = Object.keys(nudgeKeys).filter(function (promptKey) {
            return promptKey === 'btn1' || promptKey === 'btn2';
        });
        return btnCountArr.length;
    };
    EditorCommonService.prototype.isButtonMigratingFromTextToFilled = function (nudge, btnChangeObj) {
        var btnCount = this.getPromptBtnCounts(nudge.changes);
        if (btnCount === 0) {
            return false;
        }
        if (btnCount === 1) {
            return btnChangeObj.previousValue === 'flat' && btnChangeObj.newValue === 'box';
        }
        if (btnChangeObj.element === 'btn1' && btnChangeObj.previousValue === 'flat' && btnChangeObj.newValue === 'box') {
            return nudge.changes.btn2.props.type !== 'box';
        }
        if (btnChangeObj.element === 'btn2' && btnChangeObj.previousValue === 'flat' && btnChangeObj.newValue === 'box') {
            return nudge.changes.btn1.props.type !== 'box';
        }
    };
    EditorCommonService.prototype.isButtonMigratingFromFilledToText = function (nudge, btnChangeObj) {
        var btnCount = this.getPromptBtnCounts(nudge.changes);
        if (btnCount === 0) {
            return false;
        }
        if (btnCount === 1) {
            return btnChangeObj.previousValue === 'box' && btnChangeObj.newValue === 'flat';
        }
        return nudge.changes.btn1.props.type !== 'box' && nudge.changes.btn2.props.type !== 'box';
    };
    EditorCommonService.prototype.updateNudgeSpacingAndBtnContainerSpacing = function (os, nudge, changeObj) {
        var _this = this;
        if (nudge === void 0) { nudge = null; }
        if (changeObj === void 0) { changeObj = {}; }
        var masterTemplate = this.getTemplateMappedMasterTemplate(os);
        if (os === 'ios' && nudge && nudge.changes && nudge.changes.btn1) {
            var promptProps_1 = nudge.changes.prompt.props;
            if (nudge.changes.btn1.props.type === 'box' || (nudge.changes.hasOwnProperty('btn2') && nudge.changes.btn2.props.type === 'box')) {
                var promptSpacing = promptProps_1.spacing.split(' ');
                promptSpacing = promptSpacing.map(function (val) {
                    var floatVal = parseFloat(_this.getNumberFromString(val)[0]);
                    return floatVal;
                });
                if (promptSpacing) {
                    var isNudgePartOfTemplateWhichBottomPaddingZero_1 = this.templateForWhichBottomPaddingBeZero.hasOwnProperty(nudge.template);
                    promptProps_1.spacing = promptSpacing.reduce(function (acc, value, index, srcArr) {
                        if (index === 2) {
                            // for nudge containing image or mcq at bottom. we need to make nudge bottom padding 0.
                            if (isNudgePartOfTemplateWhichBottomPaddingZero_1) {
                                acc[index] = '0px';
                            }
                            else {
                                // srcArr contains spacing value (top, right, bottom, left).
                                // out of which left value remains constant for all nudge. hence using it.
                                acc[index] = srcArr[3] + 'px';
                            }
                        }
                        else {
                            acc[index] = value + 'px';
                        }
                        return acc;
                    }, []).join(' ');
                }
                promptProps_1.btnContainerSpacing = '0px 0px 0px 0px';
            }
            else {
                var promptSpacing_1 = promptProps_1.spacing.split(' ');
                promptSpacing_1 = promptSpacing_1.map(function (val) {
                    var floatVal = parseFloat(_this.getNumberFromString(val)[0]);
                    return floatVal;
                });
                var btnSpacing = promptProps_1.btnContainerSpacing.split(' ').map(function (val) { return parseFloat(_this.getNumberFromString(val)[0]); });
                if (promptSpacing_1) {
                    promptProps_1.btnContainerSpacing = btnSpacing.map(function () {
                        if (os !== 'web' && promptProps_1.nudge_type === 'spotlight') {
                            var val = promptSpacing_1[3] < 10 ? 10 : promptSpacing_1[3];
                            return val + "px";
                        }
                        return promptSpacing_1[3] + "px";
                    }).join(' ');
                    promptProps_1.spacing = promptSpacing_1.reduce(function (acc, value, index) {
                        if (index === 2) {
                            acc[index] = '0px';
                        }
                        else {
                            acc[index] = value + 'px';
                        }
                        return acc;
                    }, []).join(' ');
                }
            }
            return;
        }
        if (os === 'android' && nudge && nudge.changes && nudge.changes.btn1) {
            var promptProps = nudge.changes.prompt.props;
            if (nudge.category !== 'alerts') {
                var btnSpacing = promptProps.btnContainerSpacing.split(' ').map(function (val) { return parseFloat(_this.getNumberFromString(val)[0]); });
                if (this.isButtonMigratingFromTextToFilled(nudge, changeObj)) {
                    promptProps.btnContainerSpacing = btnSpacing.map(function (value) { return ((value * 24) / 16) + 'px'; }).join(' ');
                }
                else if (this.isButtonMigratingFromFilledToText(nudge, changeObj)) {
                    promptProps.btnContainerSpacing = btnSpacing.map(function (value) { return ((value * 16) / 24) + 'px'; }).join(' ');
                }
            }
        }
    };
    EditorCommonService.prototype.getTemplateMappedMasterTemplate = function (os) {
        if (this.masterTemplate.hasOwnProperty(os)) {
            return this.masterTemplate[os];
        }
        var prompts = this.getMasterTemplate(os);
        var osTemplate = prompts.reduce(function (acc, curObj) {
            acc[curObj['template']] = curObj;
            return acc;
        }, {});
        this.masterTemplate[os] = osTemplate;
        return osTemplate;
    };
    EditorCommonService.prototype.getMasterTemplate = function (os) {
        switch (os) {
            case 'android':
                return cloneDeep(androidPromptsJson.prompts);
            case 'ios':
                return cloneDeep(iosPromptsJson.prompts);
            case 'web':
                return cloneDeep(webPromptsJson.prompts);
            case 'web-mobile':
                return cloneDeep(webMobilePromptsJson.prompts);
            default:
                return cloneDeep(webPromptsJson.prompts);
        }
    };
    EditorCommonService.prototype.getQuantifier = function () {
        return this.quantifier;
    };
    EditorCommonService.prototype.setQuantifier = function (val) {
        this.quantifier = val;
    };
    EditorCommonService.prototype.getNumberFromString = function (str) {
        // regex for matching  integer, floats or negative numbers from string
        var numberPattern = /^-?\d+(\.[0-9]*)?/g;
        return str.trim().match(numberPattern) || [];
    };
    EditorCommonService.prototype.getQuantifierFromString = function (str) {
        // regex for matching anything except numbers
        var quantifierPattern = /\D+/g;
        return str.trim().match(quantifierPattern) || [];
    };
    EditorCommonService.prototype.getUpdatedSpacingValues = function (valueToUpdate, scaleFactor) {
        var _this = this;
        return valueToUpdate.split(' ').map(function (val, i) {
            // returns an array of matched number from string. for e.g. 12px returns ['12']
            var valueArr = _this.getNumberFromString(val);
            // returns an array of matched quantifier from string. for e.g. 12em returns ['em'], -12% returns ['-', '%']
            var quantifierValueArr = _this.getQuantifierFromString(val);
            var value;
            var quantifier;
            var quantifierValueArrLen = quantifierValueArr.length;
            if (valueArr && valueArr.length) {
                value = parseFloat(valueArr[0]);
                if (scaleFactor) {
                    value = value * scaleFactor;
                }
            }
            if (i === 0) {
                if (quantifierValueArr && quantifierValueArrLen) {
                    if (quantifierValueArrLen === 1) {
                        quantifier = quantifierValueArr[0];
                    }
                    else {
                        quantifier = quantifierValueArr[quantifierValueArrLen - 1];
                    }
                }
                else {
                    quantifier = 'px';
                }
                _this.setQuantifier(quantifier);
            }
            val = value;
            return val;
        });
    };
    EditorCommonService.prototype.handleImageMaxTopSpacing = function (imageProperties, promptData) {
        var promptNameWithImageAsFirst = this.getPromptsWithImageAsFirst();
        if (!promptNameWithImageAsFirst.hasOwnProperty(promptData.template)) {
            return;
        }
        var promptContainer = document.querySelector('#prompt');
        if (!promptContainer) {
            return;
        }
        var width = promptContainer.getBoundingClientRect().width;
        var imageWidth = ((imageProperties.width.value) / 100) * width;
        imageProperties.maxTopSpacing = Math.round((width - imageWidth) / 2);
        if (imageProperties.maxTopSpacing > 24) {
            imageProperties.maxTopSpacing = 24;
        }
    };
    /**
     * returns the container values.
     * we modify certain values to adhere to maxValue and update maxValue in special cases.
     */
    EditorCommonService.prototype.getContainerValues = function (spacing, scaleFactor, propKey, propsType, nudge) {
        var _this = this;
        var newValues = this.getUpdatedSpacingValues(spacing, scaleFactor);
        var scalingPlatformOs = this.getScalingPlatformVal();
        var maxValObj = this.getMaxValueOfProps(scalingPlatformOs, nudge);
        // tslint:disable-next-line: max-line-length
        var maxValue = (maxValObj.hasOwnProperty(propsType) && maxValObj[propsType].hasOwnProperty(propKey) && maxValObj[propsType][propKey]) || null;
        return newValues.map(function (val, index) {
            if (propKey === 'spacing' && nudge.category === 'alerts') {
                switch (index) {
                    case 1:
                        maxValue = 34;
                        break;
                    default: maxValue = 16;
                }
            }
            if (propKey === 'btnContainerSpacing') {
                if (nudge.category === 'alerts') {
                    maxValue = 16;
                }
                else if (nudge['changes'] && _this.getPromptBtnCounts(nudge['changes']) !== 0) {
                    var nudgeChanges = nudge['changes'];
                    if (scalingPlatformOs === 'ios') {
                        maxValue = 24;
                    }
                    else {
                        if (nudgeChanges.hasOwnProperty('btn1')) {
                            // tslint:disable-next-line: max-line-length
                            if (nudgeChanges.btn1.props.type === 'box' || (nudgeChanges.hasOwnProperty('btn2') && nudgeChanges.btn2.props.type === 'box')) {
                                maxValue = 24;
                            }
                            else {
                                maxValue = 16;
                            }
                        }
                        else if (nudgeChanges.hasOwnProperty('btn2')) {
                            if (nudgeChanges.btn2.props.type === 'box') {
                                maxValue = 24;
                            }
                            else {
                                maxValue = 16;
                            }
                        }
                    }
                }
            }
            if (scalingPlatformOs === 'web' && propsType === 'btnX-new' && propKey === 'fontSize') {
                val = val > 24 ? 24 : val;
            }
            else if (maxValue !== null) {
                val = val > maxValue ? maxValue : val;
            }
            if (scalingPlatformOs !== 'web' && (propsType === 'label0' || propsType === 'label1')) {
                val = val && val < 12 ? 12 : val;
            }
            if (scalingPlatformOs !== 'web' && nudge.changes.prompt.props.nudge_type === 'spotlight' && propKey === 'btnContainerSpacing') {
                val = val < 10 ? 10 : val;
            }
            // tslint:disable-next-line: max-line-length
            if (scalingPlatformOs === 'web' && nudge.changes.prompt.props.view === WebView.DESKTOP && (propsType === 'btn1' || propsType === 'btn2') && propKey === 'height') {
                var width = nudge.changes.prompt.props.width.value;
                if (width >= 30) {
                    val = 44;
                }
                else {
                    val = (44 * width) / 30;
                }
            }
            if (scalingPlatformOs !== 'web' && _this.mapOfNudgesWithImgOnSide.hasOwnProperty(nudge.template)) {
                if (propsType === 'label6') {
                    val = (val >= 0 && val < 3) ? 3 : (val >= 0 && val > 6) ? 6 : val;
                }
                /**
                 * for tooltip5 and 6, we keep the max value for btnX spacing to 5 so that it won't overlap
                 * with the image/text
                 */
                if (propsType === 'btnX-new') {
                    var width = nudge.changes.prompt.props.width.value;
                    var spacingValue = void 0;
                    if (width <= 50) {
                        spacingValue = 2;
                    }
                    else {
                        spacingValue = width / 20;
                    }
                    val = spacingValue;
                }
            }
            return "" + val + _this.getQuantifier();
        }).join(' ');
    };
    EditorCommonService.prototype.handlePromptsPropertyScaling = function (prompts, scaleFactor, propsType, promptData, os, currWidth) {
        var _this = this;
        var keys = Object.keys(prompts.props);
        var scaleValueMap = this.getScaledValueMap(os, promptData.template);
        keys.forEach(function (key) {
            if (scaleValueMap.hasOwnProperty(propsType) && scaleValueMap[propsType].hasOwnProperty(key)) {
                if (Number.isFinite(prompts.props[key])) { // value is of number type
                    if (propsType !== 'btnX-new') {
                        // if (key === 'fontSize') {
                        //   const newFontSize = prompts.props[key] * scaleFactor;
                        //   if ((promptData.template === 'important_information' || promptData.template === 'pnc_tooltip_1') && newFontSize < 6) {
                        //     prompts.props[key] = 6;
                        //   } else {
                        //     prompts.props[key] = newFontSize;
                        //   }
                        //   if (os === 'web' && propsType === 'nps' && (prompts.props[key] > 14 || prompts.props[key] < 14)) {
                        //     prompts.props[key] = 14;
                        //   }
                        // }
                        if (key === 'maxTopSpacing') {
                            var topVal = prompts.props[key] * scaleFactor;
                            prompts.props[key] = topVal > 24 ? 24 : topVal;
                        }
                    }
                    else {
                        if (key === 'fontSize' && os !== 'web') {
                            _this.handleBtnXFontSizeScaling(scaleFactor, key, prompts, os, currWidth);
                        }
                        else if (key === 'fontSize' && os === 'web') {
                            _this.handleBtnXFontSizeScalingForWeb(promptData.changes, prompts, os, currWidth);
                        }
                    }
                }
                else if (key === 'columns') {
                    _this.handleColumnsPropertyScaling(prompts.props[key], scaleFactor, key, promptData, os, currWidth);
                }
                else {
                    if (key === 'iconSize') {
                        _this.handleBtnXIconSizeScaling(scaleFactor, key, prompts, currWidth);
                    }
                    else if (key === 'spacing' && os === 'web' && propsType === 'btnX-new') {
                        _this.handleBtnXSpacingChangesForWeb(promptData.changes, promptData.template);
                    }
                    else {
                        // tslint:disable-next-line: max-line-length
                        var newSpacing = _this.getContainerValues(prompts.props[key], scaleFactor, scaleValueMap[propsType][key], propsType, promptData);
                        if (newSpacing) {
                            prompts.props[key] = newSpacing.trim();
                        }
                    }
                }
            }
        });
    };
    EditorCommonService.prototype.handleColumnsPropertyScaling = function (columns, scaleFactor, propsType, promptData, os, currWidth) {
        var _this = this;
        columns.forEach(function (column) {
            var newSpacing = _this.getContainerValues(column.spacing, scaleFactor, 'spacing', propsType, promptData);
            if (newSpacing) {
                column.spacing = newSpacing.trim();
            }
            column.components.forEach(function (component) {
                _this.handlePromptsPropertyScaling(component, scaleFactor, component.props.trackKey, promptData, os, currWidth);
            });
        });
    };
    EditorCommonService.prototype.handleNudgePropertyScaling = function (currWidth, prevWidth, prompts, os) {
        var _this = this;
        var promptData = prompts.changes;
        if (currWidth && prevWidth && promptData) {
            this.setScalingPlatformVal(os);
            var scaleFactor_1 = currWidth / prevWidth;
            var keys = Object.keys(promptData);
            keys.forEach(function (key) {
                _this.handlePromptsPropertyScaling(promptData[key], scaleFactor_1, key, prompts, os, currWidth);
                if (promptData[key]['type'] === 'h_card') {
                    _this.handlePromptsPropertyScaling(promptData[key]['props']['img2'], scaleFactor_1, 'img2', prompts, os, currWidth);
                    _this.handlePromptsPropertyScaling(promptData[key]['props']['label4'], scaleFactor_1, 'label4', prompts, os, currWidth);
                    if (os !== 'web' && _this.mapOfNudgesWithImgOnSide.hasOwnProperty(prompts.template)) {
                        if (promptData[key]['props']['label6']) {
                            _this.handlePromptsPropertyScaling(promptData[key]['props']['label6'], scaleFactor_1, 'label6', prompts, os, currWidth);
                        }
                    }
                }
            });
            if (promptData.hasOwnProperty('multiChoice') && os === 'ios') {
                var multiChoiceProps = promptData['multiChoice']['props'];
                var promptSpacing = promptData['prompt']['props']['spacing'];
                multiChoiceProps['spacing'] = this.applyNegativeSpacingValues(promptSpacing, multiChoiceProps['spacing'].split(' '));
            }
            this.setScalingPlatformVal();
        }
    };
    EditorCommonService.prototype.isInt = function (n) {
        return n % 1 === 0;
    };
    EditorCommonService.prototype.roundOffScalingValue = function (os, prompts, promptsKey, template) {
        var _this = this;
        var keys = Object.keys(prompts.props);
        var scaleValueMap = this.getScaledValueMap(os, template);
        keys.forEach(function (key) {
            if (scaleValueMap.hasOwnProperty(promptsKey) && scaleValueMap[promptsKey].hasOwnProperty(key)) {
                var roundedValues = 0;
                if (Number.isFinite(prompts.props[key])) {
                    if (os !== 'web') {
                        roundedValues = Math.round(prompts.props[key]);
                    }
                    else {
                        var numberVal = Number(prompts.props[key]);
                        roundedValues = _this.isInt(numberVal) ? numberVal : parseFloat(numberVal.toFixed(4));
                    }
                }
                else if (key === 'columns') {
                    // columns array, no need to do anything.
                    roundedValues = prompts.props[key];
                }
                else {
                    var valuesToRoundOff = _this.getUpdatedSpacingValues(prompts.props[key]);
                    roundedValues = valuesToRoundOff.map(function (val) {
                        if (os !== 'web') {
                            return "" + Math.round(val) + _this.getQuantifier();
                        }
                        else {
                            var number = Number(val);
                            var numberVal = _this.isInt(number) ? number : parseFloat(number.toFixed(4));
                            return "" + numberVal + _this.getQuantifier();
                        }
                    }).join(' ');
                }
                prompts.props[key] = roundedValues;
            }
        });
    };
    EditorCommonService.prototype.roundOffColContainerScalingValue = function (os, prompts, template) {
        var _this = this;
        prompts.props.columns.forEach(function (column) {
            var valuesToRoundOff = _this.getUpdatedSpacingValues(column.spacing);
            column.spacing = valuesToRoundOff.map(function (val) {
                var number = Number(val);
                var numberVal = _this.isInt(number) ? number : parseFloat(number.toFixed(4));
                return "" + numberVal + _this.getQuantifier();
            }).join(' ');
            column.components.forEach(function (component) {
                _this.roundOffScalingValue(os, component, component.props.trackKey, template);
            });
        });
    };
    EditorCommonService.prototype.setScalingPlatformVal = function (os) {
        if (os === void 0) { os = null; }
        this.scalingPlatformVal = os;
    };
    EditorCommonService.prototype.getScalingPlatformVal = function () {
        return this.scalingPlatformVal;
    };
    EditorCommonService.prototype.roundNudgesValues = function (os, promptChangeObj, template) {
        var _this = this;
        if (promptChangeObj === void 0) { promptChangeObj = {}; }
        var nudgeKeys = Object.keys(promptChangeObj);
        nudgeKeys.forEach(function (nudgeKey) {
            _this.roundOffScalingValue(os, promptChangeObj[nudgeKey], nudgeKey, template);
            if (promptChangeObj[nudgeKey]['type'] === 'h_card') {
                _this.roundOffScalingValue(os, promptChangeObj[nudgeKey]['props']['img2'], 'img2', template);
                _this.roundOffScalingValue(os, promptChangeObj[nudgeKey]['props']['label4'], 'label4', template);
                if (os !== 'web' && _this.mapOfNudgesWithImgOnSide.hasOwnProperty(template)) {
                    if (promptChangeObj[nudgeKey]['props']['label6']) {
                        _this.roundOffScalingValue(os, promptChangeObj[nudgeKey]['props']['label6'], 'label6', template);
                    }
                }
            }
            if (promptChangeObj[nudgeKey]['type'] === 'col-container') {
                _this.roundOffColContainerScalingValue(os, promptChangeObj[nudgeKey], template);
            }
        });
    };
    EditorCommonService.prototype.handleBtnXSpacingChanges = function (promptData, template) {
        var width = promptData['prompt']['props']['width']['value'];
        var spacing = Math.round((width * 10) / 100);
        if (this.mapOfNudgesWithImgOnSide.hasOwnProperty(template)) {
            /**
             * for nudges with image on isde, we keep the max value for btnX spacing to 5 so that it won't overlap
             * with the image/text
             */
            var spacingValue = void 0;
            if (width <= 50) {
                spacingValue = 2;
            }
            else {
                spacingValue = Math.round(width / 20);
            }
            spacing = spacingValue;
        }
        promptData['btnX-new']['props']['spacing'] = spacing + "px " + spacing + "px " + spacing + "px " + spacing + "px";
    };
    EditorCommonService.prototype.handleBtnXFontSizeScaling = function (scaleFactor, key, prompts, os, promptWidth) {
        scaleFactor = promptWidth / 100;
        if (promptWidth < 50) {
            var bgSize = this.defaultValueOfBtnXBelowFiftyPercent.bgSize;
            prompts.props.fontSize = this.defaultValueOfBtnXBelowFiftyPercent.fontSize;
            prompts.props.bgSize = bgSize + "px " + bgSize + "px";
            if (os === 'android') {
                prompts.props.fontWidth = this.defaultValueOfBtnXBelowFiftyPercent.fontWidth;
            }
        }
        else {
            var fontSize = 18 * scaleFactor;
            prompts.props[key] = fontSize;
            var bgSize = fontSize + 2; // +2 is to offset border that is applied on btnX  while selected
            prompts.props.bgSize = bgSize + "px " + bgSize + "px";
            if (os === 'android') {
                prompts.props.fontWidth = 1.5;
            }
        }
    };
    EditorCommonService.prototype.handleBtnXIconSizeScaling = function (scaleFactor, key, prompts, promptWidth) {
        scaleFactor = promptWidth / 100;
        if (promptWidth < 50) {
            var iconSize = this.defaultValueOfBtnXBelowFiftyPercent.iconSize;
            prompts.props.iconSize = iconSize + "px " + iconSize + "px";
        }
        else {
            var iconSize = 10 * scaleFactor;
            prompts.props[key] = iconSize + "px " + iconSize + "px";
        }
    };
    EditorCommonService.prototype.handleBtnXScalingChanges = function (promptData, os) {
        if (os === 'web') {
            return;
        }
        var promptWidth = promptData.prompt.props.width.value;
        var scaleFactor = promptWidth / 100;
        this.handleBtnXFontSizeScaling(scaleFactor, 'fontSize', promptData['btnX-new'], os, promptWidth);
        this.handleBtnXIconSizeScaling(scaleFactor, 'iconSize', promptData['btnX-new'], promptWidth);
    };
    EditorCommonService.prototype.applyNegativeSpacingValues = function (spacing, spacingArr) {
        var _this = this;
        spacingArr = spacingArr.map(function (val) { return parseFloat(_this.getNumberFromString(val)[0]); });
        return spacing.split(' ').map(function (val, i) {
            var value;
            var valueArr = _this.getNumberFromString(val);
            value = parseFloat(valueArr[0]);
            if (i % 2 !== 0) {
                value = -valueArr[0];
            }
            else {
                value = spacingArr[i];
            }
            if (i === 0) {
                var quantifierValueArr = _this.getQuantifierFromString(val);
                var quantifier = void 0;
                var quantifierValueArrLen = quantifierValueArr.length;
                if (quantifierValueArr && quantifierValueArrLen) {
                    if (quantifierValueArrLen === 1) {
                        quantifier = quantifierValueArr[0];
                    }
                    else {
                        quantifier = quantifierValueArr[quantifierValueArrLen - 1];
                    }
                }
                else {
                    quantifier = 'px';
                }
                _this.setQuantifier(quantifier);
            }
            val = value;
            return val + _this.getQuantifier();
        }).join(' ');
    };
    /**
     * on image load we calculate the aspect ratio of image (imageHeight/imageWidth)
     */
    EditorCommonService.prototype.updateAspectRatioOfImage = function (promptData, imageKey) {
        var imageElement = document.querySelector("." + imageKey);
        if (!imageElement) {
            return;
        }
        var imageRect = imageElement.getBoundingClientRect();
        var imageAspectRatio = parseFloat((imageRect.height / imageRect.width).toFixed(2));
        if (imageKey === 'image1' && promptData.hasOwnProperty('img1')) {
            promptData.img1.props.imgAspectRatio = imageAspectRatio;
        }
        else if (imageKey === 'image2' && promptData.hasOwnProperty('h_card')) {
            promptData.h_card.props.img2.props.imgAspectRatio = imageAspectRatio;
        }
        else if (imageKey === 'image3' && promptData.hasOwnProperty('img3')) {
            promptData.img3.props.imgAspectRatio = imageAspectRatio;
        }
    };
    EditorCommonService.prototype.getMaxHeight = function (promptData, height, nudgeBorderThickness, screenShot, btnContainer) {
        var maxHeight = 0;
        if (promptData['prompt']['props']['nudge_type'] === 'tooltip') {
            if (!btnContainer) {
                maxHeight = height - (nudgeBorderThickness * 2);
            }
            else {
                // 12 will offset tooltip height value
                // need to offset borderThickess as well so that it'll prevent the nudge from going outside of the dialog container
                maxHeight = height - 12 - (nudgeBorderThickness * 2);
            }
        }
        else if (promptData['prompt']['props']['nudge_type'] === 'spotlight') {
            // need to offset borderThickess so that it'll prevent the nudge from going outside of the dialog container
            if (!screenShot) {
                maxHeight = height - (nudgeBorderThickness * 2);
            }
            else {
                var initialMargin = 8;
                var nudgeWidth = (promptData.prompt.props.width.value / 100) * screenShot['w'];
                if ((screenShot['w'] - nudgeWidth) < 2 * initialMargin) {
                    initialMargin = (screenShot['w'] - nudgeWidth) / 2;
                }
                maxHeight = height - initialMargin - (nudgeBorderThickness * 2);
            }
        }
        else {
            if (screenShot['w'] > screenShot['h'] && !btnContainer) {
                // landscape mode and no button
                maxHeight = height - 8 - (nudgeBorderThickness * 2);
            }
            else {
                // for hotspot, 12px (tooltip height) + 8px (half of hotspot circle)
                maxHeight = height - 20 - (nudgeBorderThickness * 2);
            }
        }
        return maxHeight;
    };
    EditorCommonService.prototype.getPixelValRelativeToPercentage = function (maxHeight, imgHeight) {
        return imgHeight * (maxHeight / 100);
    };
    EditorCommonService.prototype.getDialogMaxHeight = function (promptData, positionRelativeToCanvasData, promptPosition, screenShot) {
        var parentCanvas = document.querySelector('#parentCanvas');
        if (Object.keys(screenShot).length === 0 || !screenShot['h'] || !parentCanvas) {
            return;
        }
        var maxHeight = positionRelativeToCanvasData['percentPosYRelativeToCanvas'];
        if (promptPosition['toolTipPosition'] === 'top') {
            maxHeight = 100 - positionRelativeToCanvasData['percentPosYRelativeToCanvas'];
        }
        var promptProps = promptData.prompt.props;
        if (promptProps.nudge_type === 'hotspot') {
            var btnContainer = document.querySelector('.footer-btn');
            if (screenShot['w'] > screenShot['h']) {
                // landscape mode
                if (!btnContainer) {
                    // if no button in hotspot. offset value is to prevent the nudge from going outside of the screen
                    maxHeight = this.getPixelValRelativeToPercentage(maxHeight, screenShot['h']) - promptData['prompt']['props']['margin'] - 8;
                }
                else {
                    // offset value is to prevent the nudge from going outside of the screen in case hotspot has button
                    maxHeight = this.getPixelValRelativeToPercentage(maxHeight, screenShot['h']) - promptData['prompt']['props']['margin'] - 16;
                }
            }
            else {
                // portrait mode. offset value is to prevent the nudge from going outside of the screen
                maxHeight = this.getPixelValRelativeToPercentage(maxHeight, screenShot['h']) - promptData['prompt']['props']['margin'] - 21;
            }
            return maxHeight;
        }
        if (promptProps.nudge_type === 'spotlight') {
            if (promptPosition.hasOwnProperty('top')) {
                maxHeight = 100 - promptPosition['top'];
            }
            else {
                maxHeight = 100 - promptPosition['bottom'];
            }
            return this.getPixelValRelativeToPercentage(maxHeight, screenShot['h']) - promptData['prompt']['props']['margin'];
        }
        // for tooltip, offset value is to prevent the nudge from going outside of the screen
        return this.getPixelValRelativeToPercentage(maxHeight, screenShot['h']) - promptData['prompt']['props']['margin'] - 12;
    };
    EditorCommonService.prototype.getContentMaxHeight = function (promptData, screenShot, scaleFactor, maxDialogHeight, btnContainer) {
        if (Object.keys(screenShot).length === 0 || !screenShot['h'] || Object.keys(scaleFactor).length === 0) {
            return;
        }
        var maxHeight = 0;
        var btnContainerSpacing = promptData['prompt']['props']['btnContainerSpacing'];
        var nudgeBorderThickness = promptData['prompt']['props']['borderThickness'];
        if (!btnContainer) {
            maxHeight = this.getMaxHeight(promptData, maxDialogHeight, nudgeBorderThickness, screenShot, btnContainer);
            return maxHeight;
        }
        try {
            var btnContainerRect = btnContainer.getBoundingClientRect();
            var btnContainerSpacingPxVal = this.getUpdatedSpacingValues(btnContainerSpacing);
            maxHeight = maxDialogHeight - (btnContainerRect.height + (btnContainerSpacingPxVal[0] * 2));
        }
        catch (error) {
            maxHeight = maxDialogHeight;
        }
        maxHeight = this.getMaxHeight(promptData, maxDialogHeight, nudgeBorderThickness, screenShot, btnContainer);
        return maxHeight;
    };
    EditorCommonService.prototype.returnSearchableDropdownInputCoord = function (formFilledClass) {
        var inputCoordinate = {};
        var searchableDropdown = document.querySelector(formFilledClass);
        if (!searchableDropdown) {
            return inputCoordinate;
        }
        if (searchableDropdown.getBoundingClientRect) {
            var coordinate = searchableDropdown.getBoundingClientRect();
            inputCoordinate = {
                left: coordinate.left,
                width: coordinate.width
            };
            var windowHeight = window.innerHeight;
            var top_1 = coordinate.top;
            var bottom = windowHeight - (top_1 + 50);
            if (bottom >= 256) {
                inputCoordinate['top'] = top_1 + 50;
            }
            else if (top_1 >= bottom) {
                inputCoordinate['bottom'] = bottom + 50;
            }
            else {
                inputCoordinate['top'] = top_1 + 50;
            }
        }
        return inputCoordinate;
    };
    EditorCommonService.prototype.handleDropdownToggle = function (opened, selectPanelClass, formFilledClass, alignVertically) {
        if (alignVertically === void 0) { alignVertically = false; }
        var inputCoordinate = {};
        /**
         * to align dropdown with the mat-select input. we calculate its left position and width.
         * and apply to the mat-select-panel parent. and once styles are applied. we turn the visibility on. so that flicker is not seen.
         */
        var searchableDropdownWrapper = document.querySelector(selectPanelClass);
        if (opened && searchableDropdownWrapper && searchableDropdownWrapper.parentElement) {
            inputCoordinate = this.returnSearchableDropdownInputCoord(formFilledClass);
            if (!Object.keys(inputCoordinate).length) {
                return;
            }
            var parent_1 = searchableDropdownWrapper.parentElement;
            parent_1.style.left = inputCoordinate.left + "px";
            parent_1.style.transform = 'translateX(0)';
            // parent.style.width = `${inputCoordinate.width}px`;
            if (alignVertically) {
                if (inputCoordinate.hasOwnProperty('top')) {
                    parent_1.style.top = inputCoordinate.top + "px";
                    parent_1.style.bottom = 'auto';
                }
                if (inputCoordinate.hasOwnProperty('bottom')) {
                    parent_1.style.bottom = inputCoordinate.bottom + "px";
                    parent_1.style.top = 'auto';
                }
            }
            searchableDropdownWrapper.style.visibility = 'visible';
        }
    };
    EditorCommonService.prototype.disableBorderRadiusData = function (data) {
        this.disableBorderRadius.next(data);
    };
    EditorCommonService.prototype.getNodeType = function (node) {
        if (typeof (node) === 'object') {
            return Object.keys(node)[0];
        }
        else {
            return null;
        }
    };
    EditorCommonService.prototype.getNodeBody = function (node) {
        var type = this.getNodeType(node);
        if (type) {
            return node[type];
        }
        else {
            return {};
        }
    };
    EditorCommonService.prototype.getPromptsList = function (node, nudgeList, getNativeNudge) {
        var body = this.getNodeBody(node);
        if (getNativeNudge) {
            nudgeList = nudgeList.concat(body.exp_stack);
        }
        else {
            nudgeList = nudgeList.concat(body.exp_stack.filter(function (x) { return x.type === 'prompt'; }));
        }
        switch (this.getNodeType(node)) {
            case 'ab_exp_node':
                for (var _i = 0, _a = body.default_statements; _i < _a.length; _i++) {
                    var statement = _a[_i];
                    nudgeList = this.getPromptsList(statement, nudgeList, getNativeNudge);
                }
                for (var _b = 0, _c = body.split; _b < _c.length; _b++) {
                    var split = _c[_b];
                    for (var _d = 0, _e = split.statements; _d < _e.length; _d++) {
                        var statement = _e[_d];
                        nudgeList = this.getPromptsList(statement, nudgeList, getNativeNudge);
                    }
                }
                break;
            case 'rollout_node':
                for (var _f = 0, _g = body.default_statements; _f < _g.length; _f++) {
                    var statement = _g[_f];
                    nudgeList = this.getPromptsList(statement, nudgeList, getNativeNudge);
                }
                for (var _h = 0, _j = body.statements; _h < _j.length; _h++) {
                    var statement = _j[_h];
                    nudgeList = this.getPromptsList(statement, nudgeList, getNativeNudge);
                }
                break;
            case 'decision_node':
                for (var _k = 0, _l = body.segments; _k < _l.length; _k++) {
                    var segment = _l[_k];
                    for (var _m = 0, _o = segment.statements; _m < _o.length; _m++) {
                        var statement = _o[_m];
                        nudgeList = this.getPromptsList(statement, nudgeList, getNativeNudge);
                    }
                }
                break;
            case 'action_node':
                for (var _p = 0, _q = body.statements; _p < _q.length; _p++) {
                    var statement = _q[_p];
                    nudgeList = this.getPromptsList(statement, nudgeList, getNativeNudge);
                }
                break;
        }
        return nudgeList;
    };
    EditorCommonService.prototype.handleSpotlightEdgeCase = function (promptData, selectedNode, scaleFactor, promptPosition, screenShot, elementTargetObject) {
        var prompt = document.querySelector('#prompt');
        if (!prompt) {
            return 0;
        }
        var promptRect = prompt.getBoundingClientRect();
        var spotlightHeight;
        if (promptData['prompt']['props']['nudge_props']['style'] === 'circle') {
            spotlightHeight = (Math.max(selectedNode['attr']['w'], selectedNode['attr']['h'])) * scaleFactor['scale'];
        }
        else {
            spotlightHeight = selectedNode['attr']['h'] * scaleFactor['scale'];
        }
        var remainingEmptySpace;
        if (elementTargetObject && Object.keys(elementTargetObject)) {
            if (promptPosition.hasOwnProperty('bottom')) {
                remainingEmptySpace = screenShot['h'] - (elementTargetObject['offsetTop'] + elementTargetObject['offsetHeight']);
            }
            else {
                remainingEmptySpace = (elementTargetObject['offsetTop'] + elementTargetObject['offsetHeight']);
            }
            var parentHeight = screenShot['h'] * scaleFactor['scale'];
            if (!isNaN(remainingEmptySpace)) {
                var verticalHeight = remainingEmptySpace + spotlightHeight;
                // formula gets applied only in case of full screen element is selected
                if ((screenShot['h'] - verticalHeight < (promptRect['height'] + 16)) && (elementTargetObject['offsetHeight'] >= screenShot['h'])) {
                    var offsetValue = (promptRect['height'] + 16 - (screenShot['h'] - verticalHeight)) * 100 / parentHeight;
                    return offsetValue;
                }
            }
        }
        return 0;
    };
    EditorCommonService.prototype.handleBtnXSpacingChangesForWeb = function (promptData, template) {
        if (promptData.prompt.props.view === WebView.NOT_SELECTED) {
            return;
        }
        var widthValue = promptData['prompt']['props']['width']['value'];
        var selectedView = promptData['prompt']['props']['view'];
        var spacing = 0;
        if (promptData['prompt']['props']['view'] === WebView.DESKTOP) {
            if (widthValue >= 50) {
                spacing = 10;
            }
            else if (widthValue <= 30) {
                spacing = 6; // (10 * 30) / 50;
                // Since we don't have bigger corner radius of pnc-prompt, changing min spacing value for btnX to 2
                if (promptData['prompt']['type'] === 'pnc-prompt') {
                    spacing = 2;
                }
            }
            else {
                spacing = Math.round((widthValue * 10) / 50);
            }
        }
        else if (selectedView === WebView.MOBILE && widthValue <= 50) {
            spacing = 5; // 10 * 50 / 100;
            // Since we don't have bigger corder radius of pnc-prompt, changing min spacing value for btnX to 2
            if (promptData['prompt']['type'] === 'pnc-prompt') {
                spacing = 2;
            }
        }
        else {
            spacing = Math.round((widthValue * 10) / 100);
        }
        if (promptData.hasOwnProperty('col-container')) {
            if (selectedView === WebView.MOBILE && template === 'pnc_tooltip_4') {
                // keep spacing to 0 on mobile so that btnX won't go ouside of nudge even if it has one line of text
                spacing = 0;
            }
            this.handleColContainerSpacing(promptData);
        }
        if (this.labelRightSpacingNameMap.hasOwnProperty(template)) {
            if (promptData['prompt']['type'] === 'pnc-prompt' && ((selectedView === WebView.DESKTOP && widthValue <= 18) || (selectedView === WebView.MOBILE && widthValue <= 30))) {
                this.handleLabelRightSpacing(promptData, template);
            }
            else if (promptData['prompt']['type'] === 'prompt' && ((selectedView === WebView.DESKTOP && widthValue <= 25) || (selectedView === WebView.MOBILE && widthValue <= 50))) {
                this.handleLabelRightSpacing(promptData, template);
            }
            else {
                // remove right spacing in case above condition doesn't match
                this.handleLabelRightSpacing(promptData, template, 0);
            }
        }
        promptData['btnX-new']['props']['spacing'] = spacing + "px " + spacing + "px 0px 0px";
    };
    EditorCommonService.prototype.handleBtnXFontSizeScalingForWeb = function (promptData, prompts, os, promptWidth) {
        if (os !== 'web') {
            return;
        }
        if (promptData.prompt.props.view === WebView.NOT_SELECTED) {
            return;
        }
        var scaleFactor = promptWidth / 100;
        if (promptData.prompt.props.view === WebView.DESKTOP) {
            if (promptWidth >= 50) {
                prompts.props['fontSize'] = 24;
                return;
            }
            if (promptWidth <= 20) {
                prompts.props['fontSize'] = 12; //Math.round(24 * 30 / 50);
                return;
            }
            scaleFactor = promptWidth / 50;
        }
        else if (promptData.prompt.props.view === WebView.MOBILE) {
            if (promptWidth <= 30) {
                prompts.props['fontSize'] = 10;
                return;
            }
            else if (promptWidth > 30 && promptWidth <= 50) {
                var newFontSize = Math.round(24 * promptWidth / 100);
                prompts.props['fontSize'] = newFontSize < 10 ? 10 : newFontSize;
                return;
            }
        }
        prompts.props['fontSize'] = Math.round(24 * scaleFactor);
    };
    EditorCommonService.prototype.getContentStyles = function (promptData) {
        var styleObj = {};
        if (promptData && promptData.hasOwnProperty('prompt')) {
            var spacingArr = promptData.prompt.props.spacing.split(' ');
            var borderRadius = promptData.prompt.props.cornerRadius - promptData.prompt.props.borderThickness;
            borderRadius = borderRadius > 0 ? borderRadius : 0;
            styleObj['border-top-left-radius'] = borderRadius + "px";
            styleObj['border-top-right-radius'] = borderRadius + "px";
            if (spacingArr && spacingArr.length) {
                styleObj['padding-top'] = spacingArr[0];
                styleObj['padding-right'] = spacingArr[1];
                styleObj['padding-bottom'] = spacingArr[2];
                styleObj['padding-left'] = spacingArr[3];
            }
        }
        return styleObj;
    };
    EditorCommonService.prototype.getDefaultMarginValueForWeb = function (promptData) {
        if (promptData.prompt.props.hasOwnProperty('view') && promptData.prompt.props.view === 'MOBILE') {
            return 8;
        }
        else {
            return 12;
        }
    };
    EditorCommonService.prototype.handleBtnScaleFactorChangesForWeb = function (selectedPrompts) {
        var promptObj = selectedPrompts.changes;
        if (promptObj.hasOwnProperty('btn1')) {
            var currHeight = this.getUpdatedSpacingValues(promptObj.btn1.props.height);
            promptObj.btn1.props.scaleFactor = currHeight[0] / 44;
        }
        if (promptObj.hasOwnProperty('btn2')) {
            var currHeight = this.getUpdatedSpacingValues(promptObj.btn2.props.height);
            promptObj.btn2.props.scaleFactor = currHeight[0] / 44;
        }
    };
    EditorCommonService.prototype.handleColContainerSpacing = function (promptData, spacing) {
        var _this = this;
        var colContainerSpacingArr = this.getUpdatedSpacingValues(promptData['col-container'].props.spacing);
        var rightSpacing = colContainerSpacingArr[1];
        if (rightSpacing) {
            rightSpacing = rightSpacing > 20 ? 20 : rightSpacing > 0 && rightSpacing < 18 ? 18 : rightSpacing; // add padding-right so that we'll have enough space between btn-x and label
            rightSpacing = spacing !== undefined && spacing === 0 ? spacing : rightSpacing;
        }
        else {
            rightSpacing = 18;
        }
        colContainerSpacingArr.splice(1, 1, rightSpacing);
        var newSpacingArr = colContainerSpacingArr.map(function (val) { return "" + val + _this.getQuantifier(); });
        promptData['col-container'].props.spacing = newSpacingArr.join(' ');
    };
    EditorCommonService.prototype.handleLabelRightSpacing = function (promptData, template, spacing) {
        var _this = this;
        var primaryLabel = this.labelRightSpacingNameMap[template];
        var currentSpacingValueArr = this.getUpdatedSpacingValues(promptData[primaryLabel]['props']['spacing']);
        var rightSpacing = currentSpacingValueArr[1];
        // if (rightSpacing) {
        //   rightSpacing = rightSpacing > 18 ? 18 : rightSpacing > 0 && rightSpacing < 16 ? 16 : rightSpacing; // add padding-right so that we'll have enough space between btn-x and label
        //   rightSpacing = spacing !== undefined && spacing === 0 ? spacing : rightSpacing;
        // } else {
        //   rightSpacing = 16;
        // }
        rightSpacing = spacing !== undefined && spacing === 0 ? spacing : 10;
        currentSpacingValueArr.splice(1, 1, rightSpacing);
        var newSpacingArr = currentSpacingValueArr.map(function (val) { return "" + val + _this.getQuantifier(); });
        promptData[primaryLabel]['props']['spacing'] = newSpacingArr.join(' ');
    };
    EditorCommonService.prototype.checkMinSupportedSDKVersion = function (latestAppAndSDKVersion, sdkMinVersion) {
        /*
          SDK's are versioned like:
          android: 1.0.0
          ios: ios-1.0.0
          web: web-1.0.0
        */
        var sdkVersionArray = latestAppAndSDKVersion.sdk_version.split('-');
        var sdkVersion = sdkVersionArray.length > 1 ? sdkVersionArray[1] : sdkVersionArray[0];
        return compareVersions.compare(sdkVersion, sdkMinVersion, '<');
    };
    EditorCommonService.prototype.getNudgeJsonBasedOnType = function (nudgeType, os) {
        var masterTemplate = this.getTemplateMappedMasterTemplate(os);
        var nudgeTemplateName = this.nameToTemplateMap[nudgeType];
        if (nudgeType && masterTemplate.hasOwnProperty(nudgeTemplateName)) {
            return masterTemplate[nudgeTemplateName].changes;
        }
        return {};
    };
    EditorCommonService.prototype.resetScrollPosition = function (element) {
        element.scrollTo({
            top: 80,
            behavior: 'smooth',
        });
    };
    EditorCommonService.prototype.handlePromptShadow = function (props, nudge_type) {
        if (nudge_type !== 'spotlight') {
            return;
        }
        setTimeout(function () {
            if (props.nudge_props.showSpotlightArrow && props.borderThickness === 0 && props.bgOpacity === 0) {
                props.showShadow = false;
            }
            else {
                props.showShadow = true;
            }
        }, 10);
    };
    /**
     * returns an object containing browser name and version
     */
    EditorCommonService.prototype.browserSpecs = function () {
        var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE', version: (tem[1] || '') };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem !== null) {
                return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
            M.splice(1, 1, tem[1]);
        }
        return { name: M[0], version: M[1] };
    };
    EditorCommonService.prototype.drawArrowHorizontally = function (promptEle, spotlightEle, promptData, screenShot, promptPosition, offsetVal) {
        var SPOTLIGHT_ARROW_GUTTER = 20;
        var styleObj = {};
        var promptProps = promptData['prompt']['props'];
        var nudge_props = promptProps['nudge_props'];
        var arrowHeight, arrowWidth;
        arrowHeight = offsetVal;
        var canvas = document.getElementById('arrow-canvas');
        var promptEleBoundingRect = promptEle.getBoundingClientRect();
        var spotlightBoundingRect = spotlightEle.getBoundingClientRect();
        var absPromptWidth = (promptData.prompt.props.width.value * screenShot['w']) / 100;
        arrowWidth = Math.abs((spotlightBoundingRect['left'] + (spotlightBoundingRect['width'] / 2)) - (promptEleBoundingRect['left'] + (promptEleBoundingRect['width'] / 2)));
        arrowWidth = arrowWidth < 12.5 ? 12.5 : arrowWidth;
        var ctx = canvas.getContext('2d');
        canvas['width'] = arrowWidth;
        canvas['height'] = arrowHeight;
        var arrowPadding = 2;
        var fromX, fromY, toX, toY;
        if (promptPosition.hasOwnProperty('top')) {
            if (arrowWidth === 12.5) {
                fromX = arrowWidth / 2;
                fromY = arrowHeight - arrowPadding;
                toX = arrowWidth / 2;
                toY = arrowPadding;
                if (promptPosition.hasOwnProperty('left')) {
                    styleObj['left'] = "calc(" + promptPosition['left'] + "% + " + ((absPromptWidth / 2) - arrowWidth / 2) + "px)";
                }
                else {
                    styleObj['right'] = "calc(" + promptPosition['right'] + "% + " + ((absPromptWidth / 2) - arrowWidth / 2) + "px)";
                }
            }
            else if (promptPosition.hasOwnProperty('left')) {
                fromX = arrowWidth - arrowPadding;
                fromY = arrowHeight - arrowPadding;
                toX = arrowPadding;
                toY = arrowPadding + 3; // adding 3 to prevent arrow clipping
                var angle = Math.atan2((toY - fromY), (toX - fromX));
                if ((angle > 1 && angle < 3) || (-1 > angle && -3 < angle)) {
                    // adding 3 to prevent arrow clipping
                    toX += 3;
                    styleObj['left'] = "calc(" + promptPosition['left'] + "% + " + ((absPromptWidth / 2) - (arrowWidth + 3)) + "px)";
                }
                else {
                    styleObj['left'] = "calc(" + promptPosition['left'] + "% + " + ((absPromptWidth / 2) - arrowWidth) + "px)";
                }
            }
            else if (promptPosition.hasOwnProperty('right')) {
                fromX = arrowPadding;
                fromY = arrowHeight;
                toX = arrowWidth - arrowPadding;
                toY = arrowPadding + 3; // adding 3 to prevent arrow clipping
                var angle = Math.atan2((toY - fromY), (toX - fromX));
                if ((angle > 1 && angle < 3) || (-1 > angle && -3 < angle)) {
                    // adding 3 to prevent arrow clipping
                    toX += 3;
                    styleObj['right'] = "calc(" + promptPosition['right'] + "% + " + ((absPromptWidth / 2) - (arrowWidth + 3)) + "px)";
                }
                else {
                    styleObj['right'] = "calc(" + promptPosition['right'] + "% + " + ((absPromptWidth / 2) - arrowWidth) + "px)";
                }
            }
            styleObj['top'] = "calc(" + promptPosition['top'] + "% - " + (arrowHeight + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
        }
        else {
            if (arrowWidth === 12.5) {
                fromX = arrowWidth / 2;
                fromY = arrowPadding;
                toX = arrowWidth / 2;
                toY = arrowHeight - arrowPadding;
                if (promptPosition.hasOwnProperty('left')) {
                    styleObj['left'] = "calc(" + promptPosition['left'] + "% + " + ((absPromptWidth / 2) - arrowWidth / 2) + "px)";
                }
                else {
                    styleObj['right'] = "calc(" + promptPosition['right'] + "% + " + ((absPromptWidth / 2) - arrowWidth / 2) + "px)";
                }
            }
            else if (promptPosition.hasOwnProperty('left')) {
                fromX = arrowWidth - arrowPadding;
                fromY = arrowPadding;
                toX = arrowPadding;
                toY = arrowHeight - arrowPadding - 3; // subtracting 3 to prevent arrow clipping
                var angle = Math.atan2((toY - fromY), (toX - fromX));
                if ((angle > 1 && angle < 3) || (-1 > angle && -3 < angle)) {
                    // adding 3 to prevent arrow clipping
                    toX += 3;
                    styleObj['left'] = "calc(" + promptPosition['left'] + "% + " + ((absPromptWidth / 2) - (arrowWidth + 3)) + "px)";
                }
                else {
                    styleObj['left'] = "calc(" + promptPosition['left'] + "% + " + ((absPromptWidth / 2) - arrowWidth) + "px)";
                }
            }
            else if (promptPosition.hasOwnProperty('right')) {
                fromX = arrowPadding;
                fromY = arrowPadding;
                toX = arrowWidth - arrowPadding;
                toY = arrowHeight - arrowPadding - 3; // subtracting 3 to prevent arrow clipping
                var angle = Math.atan2((toY - fromY), (toX - fromX));
                if ((angle > 1 && angle < 3) || (-1 > angle && -3 < angle)) {
                    // adding 3 to prevent arrow clipping
                    toX -= 3;
                    styleObj['right'] = "calc(" + promptPosition['right'] + "% + " + ((absPromptWidth / 2) - (arrowWidth - 3)) + "px)";
                }
                else {
                    styleObj['right'] = "calc(" + promptPosition['right'] + "% + " + ((absPromptWidth / 2) - arrowWidth) + "px)";
                }
            }
            styleObj['bottom'] = "calc(" + promptPosition['bottom'] + "% - " + (arrowHeight + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
        }
        if (nudge_props['spotlightPointerType'] === 'arrow') {
            this.drawLineWithPointerArrow(ctx, { x: fromX, y: fromY }, { x: toX, y: toY }, nudge_props['spotlightArrowColor']);
        }
        else {
            this.drawLineWithPointerCircle(ctx, { x: fromX, y: fromY }, { x: toX, y: toY }, promptPosition, promptProps);
        }
        return styleObj;
    };
    ;
    EditorCommonService.prototype.drawLineWithPointerArrow = function (ctx, p1, p2, fillColor) {
        var arrowHeadSize = 6;
        var angle = Math.atan2((p2.y - p1.y), (p2.x - p1.x));
        var hyp = Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));
        ctx.save();
        ctx.translate(p1.x, p1.y);
        ctx.rotate(angle);
        // line
        ctx.strokeStyle = fillColor || '#fff';
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.lineTo(hyp - arrowHeadSize, 0);
        ctx.stroke();
        // triangle
        ctx.fillStyle = fillColor || '#fff';
        ctx.beginPath();
        ctx.lineTo(hyp - 10, arrowHeadSize);
        ctx.lineTo(hyp, 0);
        ctx.lineTo(hyp - 10, -arrowHeadSize);
        ctx.fill();
        ctx.restore();
    };
    EditorCommonService.prototype.drawLineWithPointerCircle = function (ctx, p1, p2, promptPosition, promptProps) {
        var arrowHeadSize = 5;
        var fillColor = promptProps.nudge_props.spotlightArrowColor;
        ctx.save();
        // line
        ctx.strokeStyle = fillColor || '#fff';
        ctx.beginPath();
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.lineTo(p1.x, p1.y);
        ctx.lineTo(p2.x, p2.y);
        ctx.stroke();
        // circle
        ctx.fillStyle = fillColor || '#fff';
        ctx.beginPath();
        var coords = {
            xCords: 0,
            yCords: 0
        };
        if (promptPosition.hasOwnProperty('top')) {
            coords.yCords = arrowHeadSize;
            if (promptPosition.hasOwnProperty('left')) {
                if (promptProps.nudgePosition !== 'left' && promptProps.nudgePosition !== 'right') {
                    coords.xCords = Math.min(p1.x, p2.x);
                }
                if (promptProps.nudgePosition === 'left') {
                    this.updateCircleCoordsOnTop(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'right') {
                    coords.xCords = Math.min(p1.x, p2.x);
                }
            }
            else {
                if (promptProps.nudgePosition !== 'left' && promptProps.nudgePosition !== 'right') {
                    this.updateCircleCoordsOnTop(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'left') {
                    this.updateCircleCoordsOnTop(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'right') {
                    coords.xCords = Math.min(p1.x, p2.x);
                }
            }
        }
        else {
            coords.xCords = arrowHeadSize + 1;
            if (promptPosition.hasOwnProperty('left')) {
                if (promptProps.nudgePosition !== 'left' && promptProps.nudgePosition !== 'right') {
                    this.updateCircleCoordsOnBottomLeft(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'left') {
                    this.updateCircleCoordsOnBottomRight(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'right') {
                    this.updateCircleCoordsOnBottomLeft(coords, p1, p2, arrowHeadSize);
                }
            }
            else {
                if (promptProps.nudgePosition !== 'left' && promptProps.nudgePosition !== 'right') {
                    this.updateCircleCoordsOnBottomRight(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'left') {
                    this.updateCircleCoordsOnBottomRight(coords, p1, p2, arrowHeadSize);
                }
                if (promptProps.nudgePosition === 'right') {
                    this.updateCircleCoordsOnBottomLeft(coords, p1, p2, arrowHeadSize);
                }
            }
        }
        ctx.arc(coords.xCords, coords.yCords, 5, 0, 2 * Math.PI);
        ctx.fill();
        ctx.restore();
    };
    EditorCommonService.prototype.setProxyForWebPnc = function (selectedPrompts) {
        var _this = this;
        selectedPrompts.changes = this.listenForObjectKeys(selectedPrompts.changes, this.raiseTriggerPromptData);
        var changeObj = selectedPrompts.changes;
        Object.keys(changeObj).forEach(function (key) {
            changeObj[key]['props'] = _this.objectObservable(changeObj[key].props, _this.raiseTriggerPromptData);
        });
    };
    EditorCommonService.prototype.getVzData = function () {
        return this.vzData;
    };
    EditorCommonService.prototype.setVzData = function (data) {
        if (data === void 0) { data = null; }
        this.vzData = data;
    };
    EditorCommonService.prototype.dummySMTEvent = function () {
        return {
            av: '',
            id: '',
            internal: false,
            ipa: false,
            name: '11',
            ven: 'smt',
            attrs: []
        };
    };
    // this method is called from multiple places. Make sure to test the changes before modifying
    EditorCommonService.prototype.getModifiedEventList = function (eventList, smtEventNameMap, os) {
        return eventList.map(function (event) {
            event.nameAlias = event.name;
            if (os === 'web') {
                //  for smt vendor, check if name is of type number and populate nameAlias with actual name from smtEventNameMap
                //  so that we can display event name
                if (event.ven === 'smt' && !isNaN(event.name) && smtEventNameMap.hasOwnProperty(event.name)) {
                    event.nameAlias = smtEventNameMap[event.name];
                }
            }
            return event;
        });
    };
    EditorCommonService.prototype.getDelayVersionWarningMap = function () {
        return this.delayVersionMap;
    };
    EditorCommonService.prototype.getDefaultValueForGoalObject = function () {
        var goalObj = {
            selectedEvent: null,
            selectedEventVendor: null,
            selectedEventType: 'generic',
            eventSearchText: null,
            eventCriteriaInvalid: false,
            eventId: '',
            eventCriteria: {},
            conditionBuilderVisible: false,
            attributesLoading: false,
            eventAttributes: [],
            showEventProperties: false,
            selectedEventProperty: null,
        };
        return goalObj;
    };
    EditorCommonService.prototype.handleGoalsForExistingAB = function (ab_exp_node) {
        if (ab_exp_node.hasOwnProperty('goal_attribution')) {
            return;
        }
        ab_exp_node.goals = [];
        ab_exp_node.goal_attribution = true;
        ab_exp_node.summary = '';
    };
    EditorCommonService.prototype.getModifiedVZData = function (vz_data) {
        var clonedViewHierarchy = cloneDeep(vz_data);
        this.getFilteredViewHierarchy(clonedViewHierarchy, clonedViewHierarchy.st, 'st');
        if (!clonedViewHierarchy.st) {
            return {};
        }
        return clonedViewHierarchy.st;
    };
    EditorCommonService.prototype.mergeFillerStr = function (str, fillerStr, postStr) {
        return "" + str + fillerStr + postStr;
    };
    EditorCommonService.prototype.getFilteredViewHierarchy = function (root, node, str) {
        if (!this.shouldViewBoxBeShown(node, root['scr'])) {
            var arr = str.split(this.stringFillerText);
            var rootCpy = root;
            for (var i = 0; i < arr.length; i++) {
                if (!rootCpy) {
                    break;
                }
                if (i === arr.length - 1) {
                    rootCpy[arr[i]] = {};
                }
                else {
                    rootCpy = rootCpy[arr[i]];
                }
            }
            return;
        }
        if (!(node && node.children)) {
            return;
        }
        for (var i = 0; i < node.children.length; i++) {
            var newStr = this.mergeFillerStr(str, this.stringFillerText, 'children');
            newStr = this.mergeFillerStr(newStr, this.stringFillerText, i);
            this.getFilteredViewHierarchy(root, node.children[i], newStr);
            if (!(node.children[i] && node.children[i].children)) {
                continue;
            }
            var areAllChildrenEmpty = true;
            for (var j = 0; j < node.children[i].children.length; j++) {
                if (Object.keys(node.children[i].children[j]).length > 0) {
                    areAllChildrenEmpty = false;
                    break;
                }
            }
            if (areAllChildrenEmpty) {
                node.children[i].children = [];
            }
        }
    };
    EditorCommonService.prototype.shouldViewBoxBeShown = function (node, screenShot) {
        if (!Object.keys(screenShot).length || !node.attr) {
            return false;
        }
        if (node.attr.ignore || node.attr.hidden) {
            return false;
        }
        var xCoordinate = node.attr.x;
        var width = node.attr.w;
        var height = node.attr.h;
        var yCoordinate = node.attr.y;
        if (width === 0 || height === 0) {
            return false;
        }
        if (screenShot.h > screenShot.w) {
            width = node.attr.w;
            height = node.attr.h;
            yCoordinate = node.attr.y;
            xCoordinate = node.attr.x;
        }
        // if the node is not partially visible in left view
        if (xCoordinate <= 0 && xCoordinate + width <= 0) {
            return false;
        }
        // if node is not partially right side of the box
        if (xCoordinate >= screenShot.w) {
            return false;
        }
        // if node is not partially in view on top
        if (yCoordinate <= 0 && yCoordinate + height <= 0) {
            return false;
        }
        // if node is not partially hidden on bottom
        if (yCoordinate >= screenShot.h) {
            return false;
        }
        return true;
    };
    EditorCommonService.prototype.applyBgStyleToNudge = function (promptData, styleObj) {
        if (promptData.prompt.props.hasOwnProperty('bgFill')) {
            // tslint:disable-next-line: max-line-length
            var _a = promptData.prompt.props.bgFill, type = _a.type, gradientColor1 = _a.gradientColor1, gradientColor2 = _a.gradientColor2, gradientAngle = _a.gradientAngle, gradientType = _a.gradientType, gradientPercentage1 = _a.gradientPercentage1, gradientPercentage2 = _a.gradientPercentage2, url = _a.url;
            if (type === 'solid') {
                styleObj['backgroundColor'] = "" + this.hexToRgbA(promptData.prompt.props.bgColor, promptData.prompt.props.bgOpacity);
            }
            else if (type === 'gradient') {
                if (gradientType === 'linear') {
                    // tslint:disable-next-line: max-line-length
                    styleObj['backgroundImage'] = "linear-gradient(" + gradientAngle + "deg, " + gradientColor1 + " " + gradientPercentage1 + "%, " + gradientColor2 + " " + gradientPercentage2 + "%)";
                }
                else {
                    // tslint:disable-next-line: max-line-length
                    styleObj['backgroundImage'] = "radial-gradient(circle at center, " + gradientColor1 + "  " + gradientPercentage1 + ", " + gradientColor2 + ")  " + gradientPercentage2;
                }
            }
            else if (type === 'image') {
                styleObj['backgroundImage'] = "url(" + url + ")";
                styleObj['backgroundSize'] = '100% 100%';
                styleObj['backgroundPosition'] = 'center';
                styleObj['backgroundRepeat'] = 'no-repeat';
            }
        }
        else {
            styleObj['backgroundColor'] = "" + this.hexToRgbA(promptData.prompt.props.bgColor, promptData.prompt.props.bgOpacity);
        }
    };
    /**
     * return rgba string from array of rgba values
     * @param arr
     */
    EditorCommonService.prototype.convertToRgbStr = function (arr) {
        return arr.reduce(function (acc, cur, i) {
            if (i === arr.length - 1) {
                acc += cur + ")";
            }
            else {
                acc += cur + ", ";
            }
            return acc;
        }, 'rgba(');
    };
    EditorCommonService.prototype.getTriangleStyles = function (promptData) {
        var styles = {};
        styles['stroke'] = promptData.prompt.props.borderColor;
        styles['stroke-width'] = promptData.prompt.props.borderThickness + "px";
        var promprProps = promptData.prompt.props;
        if (promprProps.hasOwnProperty('bgFill') && promprProps.bgFill.type !== 'solid') {
            styles['fill'] = '#FFFFFF';
        }
        else {
            styles['fill'] = promptData.prompt.props.bgColor;
        }
        return styles;
    };
    EditorCommonService.prototype.bgImgURLInvalid = function (flag) {
        this.promptBGImgURLError.next(flag);
    };
    EditorCommonService.prototype.returnHexCode = function (absRem) {
        var obj = {
            10: 'A',
            11: 'B',
            12: 'C',
            13: 'D',
            14: 'E',
            15: 'F'
        };
        if (absRem > 9) {
            return obj[absRem];
        }
        else {
            return absRem;
        }
    };
    EditorCommonService.prototype.rgbaToHex = function (arr) {
        var str = '#';
        for (var i = 0; i < arr.length; i++) {
            // for opacity we need to multiply by 255
            /**
             * https://stackoverflow.com/questions/49974145/how-to-convert-rgba-to-hex-color-code-using-javascript
             *
             * https://www.developintelligence.com/blog/2017/02/rgb-to-hex-understanding-the-major-web-color-codes/
             */
            if (i === arr.length - 1 && arr.length === 4) {
                arr[i] = arr[i] * 255;
            }
            var rem = arr[i] / 16;
            str += this.returnHexCode(parseInt(rem));
            // check if number is of float type
            if (Number(rem) === rem && rem % 1 !== 0) {
                var floating = (parseFloat(('' + rem).match(/\.[0-9]*$/)[0]) * 16);
                var hexNum = parseInt(floating, 10);
                str += this.returnHexCode(hexNum);
            }
            else {
                str += 0;
            }
        }
        return str;
    };
    EditorCommonService.prototype.versionCompare = function (v1, v2, options) {
        var lexicographical = options && options.lexicographical, zeroExtend = options && options.zeroExtend, v1parts = v1.split('.'), v2parts = v2.split('.');
        function isValidPart(x) {
            return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
        }
        if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
            return NaN;
        }
        if (zeroExtend) {
            while (v1parts.length < v2parts.length)
                v1parts.push('0');
            while (v2parts.length < v1parts.length)
                v2parts.push('0');
        }
        if (!lexicographical) {
            v1parts = v1parts.map(Number);
            v2parts = v2parts.map(Number);
        }
        for (var i = 0; i < v1parts.length; ++i) {
            if (v2parts.length == i) {
                return 1;
            }
            if (v1parts[i] == v2parts[i]) {
                continue;
            }
            else if (v1parts[i] > v2parts[i]) {
                return 1;
            }
            else {
                return -1;
            }
        }
        if (v1parts.length != v2parts.length) {
            return -1;
        }
        return 0;
    };
    EditorCommonService.prototype.getPlatformOS = function () {
        var userAgent = window.navigator.userAgent;
        var os = null;
        var isIOS = (/iPad|iPhone|iPod/.test(userAgent) ||
            (/Mac|Mac OS|MacIntel/gi.test(userAgent) && (navigator.maxTouchPoints > 1 || 'ontouchend' in document)));
        if (/Macintosh|Mac|Mac OS|MacIntel|MacPPC|Mac68K/gi.test(userAgent)) {
            os = 'Mac OS';
        }
        else if (isIOS) {
            os = 'iOS';
        }
        else if (/'Win32|Win64|Windows|Windows NT|WinCE/gi.test(userAgent)) {
            os = 'Windows';
        }
        else if (/Android/gi.test(userAgent)) {
            os = 'Android';
        }
        else if (/Linux/gi.test(userAgent)) {
            os = 'Linux';
        }
        return os;
    };
    EditorCommonService.prototype.getElementCoord = function (querySelector) {
        try {
            var el = document.querySelector(querySelector);
            return el.getBoundingClientRect();
        }
        catch (e) {
            console.error(e);
            return {};
        }
    };
    EditorCommonService.prototype.captureWebPncScreen = function (st) {
        var _this = this;
        var track, stream;
        var wrapperRectCoord = this.getElementCoord('#hansel-iframe');
        var options = {
            audio: false,
            video: true,
            preferCurrentTab: true,
            selfBrowserSurface: 'include'
        };
        var mediaDevices = window.self.navigator.mediaDevices;
        return mediaDevices.getDisplayMedia(options)
            .then(function (captureStream) {
            stream = captureStream;
            track = captureStream.getVideoTracks()[0];
            var imgCapture = new ImageCapture(track);
            return imgCapture.grabFrame();
        })
            .then(function (imageBitmap) {
            var canvas = document.createElement('canvas');
            _this.drawCanvas(canvas, imageBitmap, wrapperRectCoord, st);
            var coord = { width: canvas.width, height: canvas.height };
            var screenShotObj = _this.getScreenShotObject(canvas, coord);
            // stop sharing
            stream.getVideoTracks().forEach(function (vidTrack) { return vidTrack.stop(); });
            return screenShotObj;
        });
    };
    EditorCommonService.prototype.drawCanvas = function (canvas, img, wrapperRectCoord, st) {
        var left = wrapperRectCoord.left, top = wrapperRectCoord.top;
        var _a = st.screenCoord, width = _a.width, height = _a.height;
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext('2d');
        // let ratio  = Math.min(canvas.width / img.width, canvas.height / img.height);
        // let x = (canvas.width - img.width * ratio) / 2;
        // let y = (canvas.height - img.height * ratio) / 2;
        context.clearRect(0, 0, canvas.width, canvas.height);
        // canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height,
        //     x, y, img.width * ratio, img.height * ratio);
        context.drawImage(img, left, top, width, height, 0, 0, width, height);
    };
    EditorCommonService.prototype.getScreenShotObject = function (canvas, coord) {
        return {
            width: coord.width,
            height: coord.height,
            img: canvas.toDataURL("image/png"),
            x: 0,
            y: 0
        };
    };
    EditorCommonService.prototype.getFilteredEventListForGoal = function (events) {
        var _this = this;
        // remove the system events
        return events.filter(function (evt) { return !_this.mapOfHiddenEventsForGoal.hasOwnProperty(evt.name); });
    };
    EditorCommonService.prototype.getFilteredEventList = function (events) {
        var _this = this;
        // remove internal events
        return events.filter(function (evt) { return !_this.mapOfHiddneInternalEvents.hasOwnProperty(evt.name); });
    };
    ;
    EditorCommonService.prototype.backdropChanage = function () {
        this.toggleBackdrop.next();
    };
    EditorCommonService.prototype.backdropBlurChanage = function () {
        this.toggleBackdropBlur.next();
    };
    EditorCommonService.prototype.shouldUpdateSpacingOnTextChange = function (os, templateName, labelType) {
        if (!os || !templateName || !labelType) {
            return false;
        }
        var templateMap = this.getTemplateMappedMasterTemplate(os);
        var labelObj = null;
        var masterPrompt = templateMap[templateName];
        if (masterPrompt['changes'] && masterPrompt['changes']['h_card'] && masterPrompt['changes']['h_card']['props'][labelType] && masterPrompt['changes']['h_card']['props'][labelType]['props']) {
            labelObj = masterPrompt['changes']['h_card']['props'][labelType]['props'];
        }
        if (masterPrompt['changes'] && masterPrompt['changes'][labelType] && masterPrompt['changes'][labelType]['props']) {
            labelObj = masterPrompt['changes'][labelType]['props'];
        }
        if (labelObj) {
            if ('spacing' in labelObj) {
                var topSpacing = labelObj.spacing.split('px')[0];
                // top spacing value will be in string
                return topSpacing !== '0';
            }
        }
        return false;
    };
    EditorCommonService.prototype.drawArrowVertically = function (promptEle, spotlightEle, promptData, promptPosition, offsetVal) {
        var SPOTLIGHT_ARROW_GUTTER = 20;
        var styleObj = {};
        var promptProps = promptData['prompt']['props'];
        var nudge_props = promptProps['nudge_props'];
        var arrowHeight, arrowWidth;
        var canvas = document.getElementById('arrow-canvas');
        var promptEleBoundingRect = promptEle.getBoundingClientRect();
        var spotlightBoundingRect = spotlightEle.getBoundingClientRect();
        arrowWidth = offsetVal;
        arrowHeight = Math.abs((spotlightBoundingRect['top'] + (spotlightBoundingRect['height'] / 2)) - (promptEleBoundingRect['top'] + (promptEleBoundingRect['height'] / 2)));
        arrowHeight = arrowHeight < 12.5 ? 12.5 : arrowHeight;
        var ctx = canvas.getContext('2d');
        canvas['width'] = arrowWidth;
        canvas['height'] = arrowHeight;
        var arrowPadding = 2;
        var coords = {
            fromX: 0,
            fromY: 0,
            toX: 0,
            toY: 0
        };
        if (promptPosition.hasOwnProperty('top')) {
            if (arrowHeight === 12.5) {
                if (promptProps.nudgePosition === 'left') {
                    this.updateCoordsForVerticallyCenteredLineFromLR(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['right'] = "calc(" + promptPosition['rightWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                else {
                    this.updateCoordsForVerticallyCenteredLineFromRL(coords, arrowPadding, arrowWidth, arrowHeight, promptProps);
                    styleObj['left'] = "calc(" + promptPosition['leftWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                styleObj['top'] = "calc(" + promptPosition['top'] + "% - " + arrowHeight / 2 + "px)";
            }
            else if (promptPosition.hasOwnProperty('left')) {
                if (promptProps.nudgePosition === 'left') {
                    this.updateCoordsForInclinedLineFromTLR(coords, arrowPadding, arrowWidth, arrowHeight, promptProps);
                    styleObj['right'] = "calc(" + promptPosition['rightWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                else {
                    this.updateCoordsForInclinedLineFromTRL(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['left'] = "calc(" + promptPosition['leftWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                styleObj['top'] = "calc(" + promptPosition['top'] + "%)";
            }
            else if (promptPosition.hasOwnProperty('right')) {
                if (promptProps.nudgePosition === 'left') {
                    this.updateCoordsForInclinedLineFromTLR(coords, arrowPadding, arrowWidth, arrowHeight, promptProps);
                    styleObj['right'] = "calc(" + promptPosition['rightWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                else {
                    this.updateCoordsForInclinedLineFromTRL(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['left'] = "calc(" + promptPosition['leftWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                styleObj['top'] = "calc(" + promptPosition['top'] + "%)";
            }
        }
        else {
            if (arrowHeight === 12.5) {
                if (promptProps.nudgePosition === 'left') {
                    this.updateCoordsForVerticallyCenteredLineFromLR(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['right'] = "calc(" + promptPosition['rightWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                else {
                    this.updateCoordsForVerticallyCenteredLineFromRL(coords, arrowPadding, arrowWidth, arrowHeight, promptProps);
                    styleObj['left'] = "calc(" + promptPosition['leftWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                styleObj['bottom'] = "calc(" + promptPosition['bottom'] + "% - " + arrowHeight / 2 + "px)";
            }
            else if (promptPosition.hasOwnProperty('left')) {
                if (promptProps.nudgePosition === 'left') {
                    this.updateCoordsForInclinedLineFromBLR(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['right'] = "calc(" + promptPosition['rightWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                else {
                    this.updateCoordsForInclinedLineFromBRL(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['left'] = "calc(" + promptPosition['leftWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                styleObj['bottom'] = "calc(" + promptPosition['bottom'] + "%)";
            }
            else if (promptPosition.hasOwnProperty('right')) {
                if (promptProps.nudgePosition === 'left') {
                    this.updateCoordsForInclinedLineFromBLR(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['right'] = "calc(" + promptPosition['rightWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                else {
                    this.updateCoordsForInclinedLineFromBRL(coords, arrowPadding, arrowWidth, arrowHeight);
                    styleObj['left'] = "calc(" + promptPosition['leftWidthFromPointer'] + "% + " + ((spotlightBoundingRect.width / 2) + SPOTLIGHT_ARROW_GUTTER / 2) + "px)";
                }
                styleObj['bottom'] = "calc(" + promptPosition['bottom'] + "%)";
            }
        }
        if (nudge_props['spotlightPointerType'] === 'arrow') {
            this.drawLineWithPointerArrow(ctx, { x: coords.fromX, y: coords.fromY }, { x: coords.toX, y: coords.toY }, nudge_props['spotlightArrowColor']);
        }
        else {
            this.drawLineWithPointerCircle(ctx, { x: coords.fromX, y: coords.fromY }, { x: coords.toX, y: coords.toY }, promptPosition, promptProps);
        }
        return styleObj;
    };
    ;
    /**
     * @param coords {object}
     * @param arrowPadding {number}
     * @param arrowWidth {number}
     * @param arrowHeight {number}
     * this method draws vertically centered line between two points from left to right
    */
    EditorCommonService.prototype.updateCoordsForVerticallyCenteredLineFromLR = function (coords, arrowPadding, arrowWidth, arrowHeight) {
        coords.fromX = arrowPadding;
        coords.fromY = arrowHeight / 2;
        coords.toX = arrowWidth - arrowPadding;
        coords.toY = arrowHeight / 2;
    };
    /**
     * @param coords {object}
     * @param arrowPadding {number}
     * @param arrowWidth {number}
     * @param arrowHeight {number}
     * this method draws vertically centered line between two points from right to left
    */
    EditorCommonService.prototype.updateCoordsForVerticallyCenteredLineFromRL = function (coords, arrowPadding, arrowWidth, arrowHeight, props) {
        coords.toX = arrowPadding;
        if (props.nudge_props['spotlightPointerType'] === 'circle') {
            coords.toX += 3; // add 3 to prevent circle clip
        }
        coords.toY = arrowHeight / 2;
        coords.fromX = arrowWidth - arrowPadding;
        coords.fromY = arrowHeight / 2;
    };
    /**
     * @param coords {object}
     * @param arrowPadding {number}
     * @param arrowWidth {number}
     * @param arrowHeight {number}
     * this method draws inclined line between two points from left to right on top part of the screem
    */
    EditorCommonService.prototype.updateCoordsForInclinedLineFromTLR = function (coords, arrowPadding, arrowWidth, arrowHeight, props) {
        coords.toX = arrowWidth - arrowPadding;
        if (props.nudge_props['spotlightPointerType'] === 'arrow') {
            coords.toX -= 3; // subtracting 3 to prevent arrow clipping
        }
        coords.toY = arrowPadding;
        coords.fromX = arrowPadding;
        coords.fromY = arrowHeight - arrowPadding;
    };
    /**
     * @param coords {object}
     * @param arrowPadding {number}
     * @param arrowWidth {number}
     * @param arrowHeight {number}
     * this method draws inclined line between two points from right to left on top part of the screem
    */
    EditorCommonService.prototype.updateCoordsForInclinedLineFromTRL = function (coords, arrowPadding, arrowWidth, arrowHeight) {
        coords.toX = arrowPadding + 3; // add 3 to prevent arrow clipping
        coords.toY = arrowPadding;
        coords.fromX = arrowWidth - 3; // subtracting 3 to prevent arrow clipping
        coords.fromY = arrowHeight - arrowPadding;
    };
    /**
     * @param coords {object}
     * @param arrowPadding {number}
     * @param arrowWidth {number}
     * @param arrowHeight {number}
     * this method draws inclined line between two points from left to right on bottom part of the screem
    */
    EditorCommonService.prototype.updateCoordsForInclinedLineFromBLR = function (coords, arrowPadding, arrowWidth, arrowHeight) {
        coords.fromX = arrowPadding;
        coords.fromY = arrowPadding;
        coords.toX = arrowWidth - arrowPadding - 3;
        coords.toY = arrowHeight - arrowPadding - 3;
    };
    /**
     * @param coords {object}
     * @param arrowPadding {number}
     * @param arrowWidth {number}
     * @param arrowHeight {number}
     * this method draws inclined line between two points from right to left on bottom part of the screem
    */
    EditorCommonService.prototype.updateCoordsForInclinedLineFromBRL = function (coords, arrowPadding, arrowWidth, arrowHeight) {
        coords.fromX = arrowWidth - arrowPadding;
        coords.fromY = arrowPadding;
        coords.toX = arrowPadding + 3; // add 3 to prevent arrow clipping
        coords.toY = arrowHeight - arrowPadding - 3;
    };
    /**
     * @param coords {object}
     * @param p1 {object}
     * @param p2 {object}
     * @param arrowHeadSize {number}
     * this method updates the coords of the circle to be drawn on the top part of the screen
    */
    EditorCommonService.prototype.updateCircleCoordsOnTop = function (coords, p1, p2, arrowHeadSize) {
        coords.xCords = Math.max(p1.x, p2.x);
        if (p1.x !== p2.x) {
            coords.xCords -= (arrowHeadSize - 1);
        }
    };
    /**
     * @param coords {object}
     * @param p1 {object}
     * @param p2 {object}
     * @param arrowHeadSize {number}
     * this method updates the coords of the circle to be drawn on the bottom left part of the screen
    */
    EditorCommonService.prototype.updateCircleCoordsOnBottomLeft = function (coords, p1, p2, arrowHeadSize) {
        coords.yCords = Math.max(p1.y, p2.y);
        if (p1.x !== p2.x) {
            coords.yCords -= (arrowHeadSize / 2 - 1);
        }
        else {
            coords.yCords -= (arrowHeadSize / 2);
        }
    };
    /**
     * @param coords {object}
     * @param p1 {object}
     * @param p2 {object}
     * @param arrowHeadSize {number}
     * this method updates the coords of the circle to be drawn on the bottom right part of the screen
    */
    EditorCommonService.prototype.updateCircleCoordsOnBottomRight = function (coords, p1, p2, arrowHeadSize) {
        coords.xCords = Math.max(p1.x, p2.x);
        coords.yCords = Math.max(p1.y, p2.y);
        if (p1.x !== p2.x) {
            coords.xCords -= (arrowHeadSize / 2);
        }
        else {
            coords.yCords -= (arrowHeadSize / 2 - 1);
        }
    };
    // this will be displayed in HTML
    EditorCommonService.prototype.convertNewLineToBR = function (props) {
        var text = this.parseVisualizerLabelTxt(props);
        text = text.replace(/\\n/g, '<br>');
        text = text.replace(/\s/g, function (match) {
            // replace \n with br but ignoring space and non-breaking space
            if (match.charCodeAt(0) !== 32 && match.charCodeAt(0) !== 160) {
                return '<br>';
            }
            return match;
        });
        return text;
    };
    // called on label-editor init to convert /n to //n
    // so that content editable can show \n inside input
    EditorCommonService.prototype.updateNewLineChangesOnLabel = function (text) {
        text = text.replace(/\n/g, "\\n");
        text = text.replace(/\s/g, function (match) {
            // replace \n with br
            if (match.charCodeAt(0) === 10) {
                return "\\n";
            }
            return match;
        });
        return text;
    };
    // rmeove \\n with \n. this data will be sent to SDK while closing the editor
    EditorCommonService.prototype.removeExtraSlashFromNewLine = function (text) {
        text = text.replace(/\\n/g, "\n");
        return text;
    };
    // returns an array of btns except btnX
    EditorCommonService.prototype.getPromptBtns = function (promptData) {
        return Object.keys(promptData).filter(function (key) { return key.includes('btn') && key !== 'btnX-new' && key !== 'btnX'; });
    };
    EditorCommonService.prototype.zIndexInvalid = function (flag) {
        this.zIndexError.next(flag);
    };
    EditorCommonService.prototype.removeUnusedTextVariable = function (properties) {
        if (!properties.hasOwnProperty('textVariables')) {
            return;
        }
        var clonedTextVariables = cloneDeep(properties.textVariables);
        var text = properties.text;
        var variableKeys = Object.keys(clonedTextVariables);
        if (!variableKeys.length) {
            return;
        }
        variableKeys.forEach(function (key) {
            // remove unused textVariable key
            if (!text.includes("{{" + key + "}}")) {
                // delete keyword has no side-effect
                delete properties.textVariables[key];
            }
        });
    };
    EditorCommonService.prototype.getUAStringForMobileDevice = function () {
        return this.userAgentStringForMobileDevice;
    };
    EditorCommonService.prototype.sendDataToExtension = function (payload) {
        /**
         * first param is the extension Id. Don't modify this value
         * for more info on how to keep the extension id same during the development, visit the below link
         * https://stackoverflow.com/a/21500707
         */
        try {
            chrome.runtime.sendMessage('mcljbejigkdjgllejddjdacbhkopgihj', payload);
        }
        catch (error) { }
    };
    EditorCommonService.prototype.vzDataLoaded = function (flag) {
        this.hasVZDataLoaded.next(flag);
    };
    // below method filter out the simulated nudges from the list and returns it
    EditorCommonService.prototype.getFilteredNudgeList = function (list) {
        return list.filter(function (nudge) { return !nudge.id.includes(':@'); });
    };
    EditorCommonService.prototype.htmlContentChange = function (html) {
        this.onHTMLContentChange.next(html);
    };
    EditorCommonService.prototype.htmlZIPLoaded = function (flag) {
        this.hasHTMLZIPLoaded.next(flag);
    };
    EditorCommonService.prototype.htmlData = function (data) {
        this.nudgeHTMLData.next(data);
    };
    EditorCommonService.prototype.getZIPIdFromURL = function (url) {
        var splitBySlash = url.split("/");
        var uniqueZIPId = splitBySlash[splitBySlash.length - 1].split(".zip")[0];
        return uniqueZIPId;
    };
    EditorCommonService.prototype.resizeIframe = function (iframe, promptData, screenShotHeight) {
        if (!promptData.hasOwnProperty('html')) {
            return;
        }
        if (iframe.contentWindow && iframe.contentWindow.document.body) {
            var scrollHeight = iframe.contentWindow.document.body.scrollHeight;
            promptData.html.props.height.value = Math.round((scrollHeight / screenShotHeight) * 100);
        }
    };
    EditorCommonService.prototype.validateHTML = function (htmlStr) {
        var clonedHTMLStr = htmlStr;
        var parsedDOM = new DOMParser().parseFromString(clonedHTMLStr, "text/html");
        if (!document.doctype) {
            return {
                error: '<!DOCTYPE> tag is missing',
                valid: false
            };
        }
        var scriptTags = parsedDOM.getElementsByTagName('script');
        var isJSSDKLinkPresent = Array.from(scriptTags).some(function (tag) { return tag.src && tag.src.includes('px-diy'); });
        if (!isJSSDKLinkPresent) {
            return {
                error: "Netcore PX js script is missing. <a href=\"https://cedocs.netcorecloud.com/docs/diy-html-based-nudges\" target=\"_blank\">Know more</a>",
                valid: false
            };
        }
        return {
            error: '',
            valid: true
        };
    };
    EditorCommonService.prototype.getDIYNudgeHeight = function (heightInPercent) {
        var promptRect = document.getElementById('prompt').getBoundingClientRect();
        var heightInPx = heightInPercent * promptRect.width / 100 + "px";
        return heightInPx;
    };
    EditorCommonService.prototype.secondaryBtnToggle = function () {
        this.secondaryBtnToggleSub.next();
    };
    EditorCommonService.prototype.colContainerImgPosChange = function () {
        this.colContainerImgPosSub.next();
    };
    EditorCommonService.prototype.saveAs = function (content, fileName, fileType) {
        var blob = new Blob([content], { type: fileType });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    /**
     *
     * @param data array vz_data data
     * @param type first type getting from vz_data
     * @param nodeIdx  default 0
     * @param os  os,ex-android,ios
     * @param originalData  original ddata
     */
    EditorCommonService.prototype.generateEIDForFlutterApp = function (data, type, nodeIdx, os, originalData) {
        var _this = this;
        data.forEach(function (e, index) {
            var svix;
            if (e.hasOwnProperty('svix')) {
                svix = _this.FLUTTER_VIEW_SEPARATOR + "svix:" + e.svix;
            }
            if (nodeIdx === 0) {
                e.eid = "" + type + _this.FLUTTER_VIEW_SEPARATOR + "ix:0" + (svix ? svix : '');
                if (os === 'android' && originalData.hasOwnProperty('act')) {
                    e.eid = "" + originalData.act + e.eid;
                }
            }
            else {
                e.eid = type + "##" + e.type + _this.FLUTTER_VIEW_SEPARATOR + "ix:" + index + (svix ? svix : '');
            }
            if (e.children)
                _this.generateEIDForFlutterApp(e.children, e.eid, 1, os, originalData);
        });
    };
    EditorCommonService.prototype.getContainerStyles = function (props, isPartialTextFormattingSupported) {
        var styleObj = {};
        styleObj['margin'] = props.spacing;
        styleObj['font-size'] = props.fontSize + "px";
        if (!isPartialTextFormattingSupported) {
            styleObj['color'] = props.textColor;
            this.addBoldItalicUnderlineStyles(styleObj, props);
        }
        styleObj['font-family'] = props.fontFamily === 'app-default' ? 'sans-serif' : props.fontFamily;
        styleObj['text-align'] = props.align;
        styleObj['line-height'] = props.fontSize + props.lineHeight + "px";
        styleObj['letter-spacing'] = props.letterSpacing + "px";
        return styleObj;
    };
    EditorCommonService.prototype.addBoldItalicUnderlineStyles = function (styleObj, props) {
        if (props.fontStyle.includes('B')) {
            styleObj['font-weight'] = 'bold';
        }
        if (props.fontStyle.includes('I')) {
            styleObj['font-style'] = 'italic';
        }
        if (props.fontStyle.includes('U')) {
            styleObj['text-decoration'] = 'underline';
        }
    };
    EditorCommonService.prototype.getButtonStyles = function (props, isPartialTextFormattingSupported) {
        var styleObj = {};
        styleObj['font-size'] = props.fontSize + "px";
        styleObj['font-family'] = props.fontFamily === 'app-default' ? 'sans-serif' : props.fontFamily;
        if (!isPartialTextFormattingSupported) {
            styleObj['color'] = props.textColor;
            this.addBoldItalicUnderlineStyles(styleObj, props);
        }
        return styleObj;
    };
    EditorCommonService.prototype.triggerWebPNCPositionChange = function () {
        this.webPNCPositions$.next();
    };
    EditorCommonService.prototype.triggerNudgePositionChange = function (data) {
        this.nudgePlacement$.next(data);
    };
    EditorCommonService.prototype.triggerAnimationChange = function (data) {
        this.nudgeAnimation$.next(data);
    };
    /**
     * add animation on nudge
     * @param promptData
     * @param element
     * @param shouldAnimateTriangle
     */
    EditorCommonService.prototype.handleNudgeAnimation = function (promptData, element, promptPosition, shouldAnimateTriangle) {
        var props = promptData.prompt.props;
        if (props.hasOwnProperty('animation')) {
            var animation = props.animation;
            if (promptData.prompt.type === 'pnc-prompt') {
                if (animation.transition === 'transition' && animation.nudgeAnimation === 'bounce') {
                    shouldAnimateTriangle = true;
                }
                else {
                    shouldAnimateTriangle = false;
                }
                this.addPNCNudgeAnimation('transition', animation.transition, promptData, shouldAnimateTriangle, promptPosition, element);
                this.addPNCNudgeAnimation('nudgeAnimation', animation.nudgeAnimation, promptData, shouldAnimateTriangle, promptPosition, element);
            }
            else {
                element.classList.remove('animate__infinite');
                element.classList.add('animate__animated');
                this.handleNonPNCNudgeAnimation('transition', animation.transition, element);
                this.handleNonPNCNudgeAnimation('nudgeAnimation', animation.nudgeAnimation, element);
            }
        }
    };
    /**
     * trigger animation changes on nudge (selection change in animation editor triggers this  method)
     * @param animationObject
     * @param promptData
     * @param element
     * @param shouldAnimateTriangle
     */
    EditorCommonService.prototype.triggerNudgeAnimation = function (animationObject, promptData, element, promptPosition, shouldAnimateTriangle) {
        if (promptData.prompt.type === 'pnc-prompt') {
            if (animationObject.type === 'transition') {
                this.addPNCNudgeAnimation('transition', animationObject.value, promptData, shouldAnimateTriangle, promptPosition, element);
            }
            else {
                this.addPNCNudgeAnimation('nudgeAnimation', animationObject.value, promptData, shouldAnimateTriangle, promptPosition, element);
            }
        }
        else {
            element.classList.add('animate__animated', 'animate__infinite');
            if (animationObject.type === 'transition') {
                this.handleNonPNCNudgeAnimation('transition', animationObject.value, element);
            }
            else {
                this.handleNonPNCNudgeAnimation('nudgeAnimation', animationObject.value, element);
            }
        }
    };
    EditorCommonService.prototype.handleNonPNCNudgeAnimation = function (type, value, element) {
        if (type === 'transition') {
            this.addNudgeTransition('transition', value, element);
        }
        else {
            this.addNudgeAnimation('nudgeAnimation', value, element);
        }
    };
    /**
     * Handle non-pnc nudge transition
     * @param type
     * @param action
     * @param element
     */
    EditorCommonService.prototype.addNudgeTransition = function (type, action, element) {
        var _a;
        (_a = element.classList).remove.apply(_a, Array.from(element.classList));
        switch (action) {
            case 'fade-in-out':
                element.classList.add('animate__animated', 'animate__fadeIn', 'animate__fadeIn_custom');
                break;
            case 'slide-from-top':
                element.classList.add('slide-from-top');
                break;
            case 'slide-from-bottom':
                element.classList.add('slide-from-bottom');
                break;
            case 'slide-from-left':
                element.classList.add('slide-from-left');
                break;
            case 'slide-from-right':
                element.classList.add('slide-from-right');
                break;
            case 'none':
                if (type === 'transition') {
                }
                break;
            default:
                break;
        }
    };
    /**
     * Handle non-pnc nudge animtion
     * @param type
     * @param action
     * @param element
     */
    EditorCommonService.prototype.addNudgeAnimation = function (type, action, element) {
        switch (action) {
            case 'bounce':
                element.classList.remove('animate__pulse', 'shine-animation');
                element.classList.add('animate__bounce_custom');
                break;
            case 'shine':
                element.classList.remove('animate__bounce_custom');
                element.classList.add('shine-animation');
                break;
            case 'none':
                if (type === 'nudgeAnimation') {
                    element.classList.remove('animate__bounce_custom', 'animate__pulse', 'shine-animation');
                }
                break;
            default:
                break;
        }
    };
    /**
     * handle pnc nudge transition and animation
     * @param type
     * @param action
     * @param promptData
     * @param shouldAnimateTriangle
     * @param html
     * @returns
     */
    EditorCommonService.prototype.addPNCNudgeAnimation = function (type, action, promptData, shouldAnimateTriangle, promptPosition, promptEle) {
        var _this = this;
        var element = promptEle;
        if (!element || !element.classList) {
            return;
        }
        var traingleElement = document.getElementById('traingle-animation');
        if (promptData.prompt.props.nudge_type !== 'tag' && (!traingleElement || !traingleElement.classList)) {
            return;
        }
        element.classList.add('animate__animated', 'animate__infinite');
        if (promptData.prompt.props.nudge_type !== 'tag' && !shouldAnimateTriangle) {
            traingleElement.classList.add('animate__animated', 'animate__infinite');
        }
        switch (action) {
            case 'bounce':
                this.addBounceAnimation(element, traingleElement, promptPosition);
                break;
            case 'shine':
                element.classList.remove('animate__bounce_custom');
                element.classList.add('shine-animation');
                traingleElement && traingleElement.classList.remove('animate__bounce_custom', 'animate__bounce_triangle');
                traingleElement && traingleElement.classList.add('shine-animation');
                break;
            case 'fade-in-out':
                this.addFadeInOutTransition(element, traingleElement, promptData, promptPosition);
                break;
            case 'none':
                if (type === 'transition') {
                    // remove bounce animation and add it again to prevent animation sync issue of triangle and nudge
                    element.classList.remove('animate__infinite', 'animate__animated', 'animate__bounce_custom', 'animate__fadeIn_custom', 'animate__fadeIn', 'animate__slower');
                    traingleElement && traingleElement.classList.remove('animate__infinite', 'animate__animated', 'animate__bounce_triangle', 'animate__bounce_custom', 'animate__fadeIn_custom', 'animate__fadeIn', 'animate__slower');
                    if (promptData.prompt.props.animation.nudgeAnimation === 'bounce') {
                        setTimeout(function () {
                            _this.addBounceAnimation(element, traingleElement, promptPosition);
                        }, 500);
                    }
                }
                else {
                    element.classList.remove('animate__animated', 'animate__bounce_custom', 'animate__pulse', 'shine-animation', 'animate__slower');
                    traingleElement && traingleElement.classList.remove('animate__fadeIn_custom', 'animate__animated', 'animate__bounce_custom', 'animate__bounce_triangle', 'animate__pulse', 'shine-animation', 'animate__slower');
                    if (promptData.prompt.props.animation.transition === 'fade-in-out') {
                        setTimeout(function () {
                            _this.addFadeInOutTransition(element, traingleElement, promptData, promptPosition);
                        }, 500);
                    }
                }
                break;
            default:
                break;
        }
    };
    EditorCommonService.prototype.addBounceAnimation = function (element, traingleElement, promptPosition) {
        element.classList.remove('shine-animation');
        element.classList.add('animate__animated', 'animate__bounce_custom', 'animate__infinite');
        traingleElement && traingleElement.classList.remove('shine-animation');
        if (promptPosition['toolTipPosition'] === 'top') {
            traingleElement && traingleElement.classList.add('animate__animated', 'animate__bounce_custom', 'animate__infinite');
        }
        else {
            traingleElement && traingleElement.classList.add('animate__animated', 'animate__bounce_triangle', 'animate__infinite');
        }
        element.classList.remove('animate__slower');
        traingleElement && traingleElement.classList.remove('animate__slower');
    };
    EditorCommonService.prototype.addFadeInOutTransition = function (element, traingleElement, promptData, promptPosition) {
        // stop the bounce animation if it's already running
        if (promptData.prompt.props.animation.nudgeAnimation === 'bounce') {
            element.classList.remove('animate__bounce_custom');
            traingleElement && traingleElement.classList.remove('animate__bounce_custom', 'animate__bounce_triangle');
        }
        element.classList.add('animate__animated', 'animate__fadeIn', 'animate__fadeIn_custom', 'animate__slower');
        traingleElement && traingleElement.classList.add('animate__animated', 'animate__fadeIn_custom', 'animate__fadeIn', 'animate__fadeIn', 'animate__slower');
        // add bounce animation after a delay of 2 sec once the fade in out is done running
        // this fixes up the triangle and nudge bounce animation not-in-sync issue
        if (promptData.prompt.props.animation.nudgeAnimation === 'bounce') {
            setTimeout(function () {
                element.classList.remove('animate__slower');
                traingleElement && traingleElement.classList.remove('animate__slower');
                element.classList.add('animate__infinite', 'animate__bounce_custom');
                traingleElement && traingleElement.classList.add('animate__infinite', 'animate__bounce_triangle');
                if (promptPosition['toolTipPosition'] === 'top') {
                    traingleElement && traingleElement.classList.add('animate__bounce_custom', 'animate__infinite');
                }
                else {
                    traingleElement && traingleElement.classList.add('animate__bounce_triangle', 'animate__infinite');
                }
            }, 2000);
        }
        element.classList.remove('slide-from-right', 'slide-from-top', 'slide-from-left', 'slide-from-bottom');
        element.classList.remove('animate__infinite');
        traingleElement && traingleElement.classList.remove('animate__infinite');
    };
    EditorCommonService.ngInjectableDef = i0.defineInjectable({ factory: function EditorCommonService_Factory() { return new EditorCommonService(i0.inject(i1.HttpClient)); }, token: EditorCommonService, providedIn: "root" });
    return EditorCommonService;
}());
export { EditorCommonService };
